var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _ellipse2, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _ellipse3, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _ellipse4, _path566, _path567, _ellipse5, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _ellipse6, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _rect, _rect2, _rect3, _path603, _path604, _rect4, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _ellipse7, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#21598a;}.cls-2{fill:#ef5b0c;}.cls-3{fill:#fea77c;}.cls-4{fill:#20140f;}.cls-5{fill:#fff;}.cls-6{fill:#cc2c3d;}.cls-7{fill:#f57d77;}.cls-8{fill:#bf453f;}.cls-9{fill:#ccc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1709.36,1459.91l-3.86-137.36a10.11,10.11,0,0,1-5.45-8.81,10.19,10.19,0,0,1,12.87-9.93L1902.43,1110a10.2,10.2,0,0,1-1-4.17,9.9,9.9,0,0,1,1.86-5.91L1627.45,737.24c2.85-1.48,5.7-3,8.56-4.47l276,362.84a10.17,10.17,0,0,1-.12,20.33,12.65,12.65,0,0,1-1.74-.16L1720,1310.18a10,10,0,0,1,.64,3.33,10.12,10.12,0,0,1-5.63,9.13l3.86,137.16.25,8.76.27,9.53a4.75,4.75,0,0,1-4.63,4.89h-.08a4.76,4.76,0,0,1-4.81-4.62l-.28-9.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1719.14,1468.56c45.52,0,81.55,6.06,81.64,14,.09,8.23-38.93,15.35-87.16,15.89s-87.41-5.71-87.5-14c-.09-8,37-15,83.49-15.83l.28,9.73a4.76,4.76,0,0,0,4.81,4.62h.08a4.75,4.75,0,0,0,4.63-4.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1524.28,730c23.32,36.08,28.35,74.32,11.23,85.37s-49.9-9.24-73.21-45.34-28.34-74.32-11.23-85.37S1501,693.9,1524.28,730Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1385.14,1458.89l-9,44a13.29,13.29,0,0,1-12.78,10.59l-619.91,5.67a7.4,7.4,0,0,1-7.21-9.59,13.69,13.69,0,0,1,12.92-9.64l220.25-2.45,71.67-338.09a26.93,26.93,0,0,1,25.74-21.33l366.52-8.23a15.46,15.46,0,0,1,15.5,18.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M910.68,298c1.59,11.6-1.09,24.31-9.47,32.47a25.64,25.64,0,0,1-9.22,5.68c-7.67,2.74-16.53,2-22.61-3.32l0-.1a31.64,31.64,0,0,0,11.94-10.39c7.46-11.06,8.22-25.43,6-38.57a60.86,60.86,0,0,0-3.16-11.71c6.76-1.22,13.86,1.88,18.5,7S909.71,291.07,910.68,298Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M817.92,328.23a72.4,72.4,0,0,0,13.48-4.52l.14.3A20.15,20.15,0,0,1,827,335.54a19.58,19.58,0,0,1-6.23,5.07h-.06A43.25,43.25,0,0,0,817.92,328.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M858.35,297.16c.81,10.12.1,20.91-5.54,29.36a23.9,23.9,0,0,1-6.59,6.59c-5.76,3.91-13.08,5.36-19.23,2.43A20.15,20.15,0,0,0,831.54,324l-.14-.3a33.93,33.93,0,0,0,9.26-6.27c6.07-5.95,9-15.83,4.78-23.17a9.82,9.82,0,0,0-6.22-4.95c-2.4-.49-4.85.26-7.18,1L823.73,293c-2.25-8.29-4.74-16.62-9.45-23.76a33.57,33.57,0,0,0-13.19-11.85v0l.13-.26c8.42-7.22,19.18-13.8,30-11.34,7.16,1.63,12.51,6.72,16.41,13.07a59.28,59.28,0,0,1,5.92,13.38A113.82,113.82,0,0,1,858.35,297.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M884.06,272.05a60.86,60.86,0,0,1,3.16,11.71c2.27,13.14,1.51,27.51-6,38.57a31.64,31.64,0,0,1-11.94,10.39c-7.24,3.64-15.72,4.44-22.86.73l-.25-.34a23.9,23.9,0,0,0,6.59-6.59c5.64-8.45,6.35-19.24,5.54-29.36a113.82,113.82,0,0,0-4.8-25,59.28,59.28,0,0,0-5.92-13.38l1.28-.81c6.69-6.81,18.72-5.59,26,.56A32.61,32.61,0,0,1,884.06,272.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M823.73,293l8.31-2.66c2.33-.75,4.78-1.5,7.18-1a9.82,9.82,0,0,1,6.22,4.95c4.26,7.34,1.29,17.22-4.78,23.17a33.93,33.93,0,0,1-9.26,6.27,72.4,72.4,0,0,1-13.48,4.52,43.25,43.25,0,0,1,2.78,12.39h.06a19.58,19.58,0,0,0,6.23-5.07c6.15,2.93,13.47,1.48,19.23-2.43l.25.34c7.14,3.71,15.62,2.91,22.86-.73l0,.1c6.08,5.33,14.94,6.06,22.61,3.32l.1.27a42.79,42.79,0,0,1-1.55,21.3c-3.21,9.55-9.72,17.78-12.49,27.47a42.9,42.9,0,0,0-.41,20.62,278.81,278.81,0,0,1-97.75-6.68l0-.16c-3.32-17.54-12.26-33.41-19.6-49.71S747.1,315,750.44,297.47c2.38-12.53,9.43-23.94,18.9-32.47,6.19-5.61,14-10.2,22.32-10a23.55,23.55,0,0,1,9.43,2.34v0a33.57,33.57,0,0,1,13.19,11.85C819,276.37,821.48,284.7,823.73,293Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.9,334.82A57.24,57.24,0,0,0,188.72,349a17.84,17.84,0,0,1-12.42-5.78l-.27-.15a38.29,38.29,0,0,0,2.3-5C183.66,337.67,189,336.07,193.9,334.82Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.52,284.22a16.48,16.48,0,0,1,3.75,2.15c3.59,2.78,5.9,6.87,8,10.92A171.41,171.41,0,0,1,146.41,329c2.21,8.1,3.57,17.59-1.57,24.22-.06.07-.12.15-.2.23-5.2,6.45-14.54,7.43-22.9,7.54a9.6,9.6,0,0,0,.89-1.82c1.17-3.15,1-6.62.51-10A84.22,84.22,0,0,0,106,308.31c-2.07-2.63-4.47-5.25-7.42-6.62l.32-.65c.8-6.91,3.2-13.38,9.94-16.56A17.27,17.27,0,0,1,122.52,284.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M711,773a8.15,8.15,0,1,1-8.05,8.25A8.16,8.16,0,0,1,711,773Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.05,272.22c10.53,9.78,17,20.18,21.66,33.77h0a69.77,69.77,0,0,0-7.36.48l-27.64,2.81c-1.19.11-2.41.26-3.64.44a78.45,78.45,0,0,0-10.42-23.11,50.93,50.93,0,0,0-5.54-7l.61-.59a27.59,27.59,0,0,1,18.66-11.57,15.32,15.32,0,0,1,7.28.47A19,19,0,0,1,190.05,272.22Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.51,719.44c2.13,1.63,3.44,4.62,2.34,7a6.31,6.31,0,0,1-4.28,3.2,26.43,26.43,0,0,1-5.48.5c-5,.19-10.08,1.3-14.19,4.14-2.16,1.49-4,3.41-6.29,4.68s-5.3,1.74-7.44.22-2.63-4.4-1.92-6.84a13.63,13.63,0,0,1,4.37-6.08,35.73,35.73,0,0,1,28.07-8.59C610.67,717.26,613.39,717.81,615.51,719.44Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.14,337.44a27.12,27.12,0,0,0,9.19.66,38.29,38.29,0,0,1-2.3,5c-2.85,5.18-6.9,9.66-12.2,12.14-6,2.83-13.7,2.42-18.85-1.54l-.34-.26c.08-.08.14-.16.2-.23,5.14-6.63,3.78-16.12,1.57-24.22a171.41,171.41,0,0,0-12.19-31.7c-2.05-4.05-4.36-8.14-8-10.92a16.48,16.48,0,0,0-3.75-2.15c3-4.51,6.2-9.18,11.09-11.4,5.31-2.45,11.75-1.46,16.83,1.44a29.75,29.75,0,0,1,6.67,5.32,50.93,50.93,0,0,1,5.54,7,78.45,78.45,0,0,1,10.42,23.11c-6.19.93-12.5,2.89-15.23,8.29C154,325.67,160.83,335.24,169.14,337.44Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.74,361c8.36-.11,17.7-1.09,22.9-7.54l.34.26c5.15,4,12.85,4.37,18.85,1.54,5.3-2.48,9.35-7,12.2-12.14l.27.15A17.84,17.84,0,0,0,188.72,349a57.24,57.24,0,0,1,5.18-14.21c-4.92,1.25-10.24,2.85-15.57,3.28a27.12,27.12,0,0,1-9.19-.66c-8.31-2.2-15.17-11.77-11.3-19.42,2.73-5.4,9-7.36,15.23-8.29,1.23-.18,2.45-.33,3.64-.44l27.64-2.81a69.77,69.77,0,0,1,7.36-.48,23.1,23.1,0,0,1,7.2,1c9.39,3.06,14.53,13.58,15,23.44s-2.63,19.47-4.61,29.14a128.85,128.85,0,0,0,4.46,67.32c-36.92,10.87-70.59,19.1-108.7,19-.22-1.11-.46-2.23-.75-3.34v0A76.27,76.27,0,0,0,112,416c-5.34-7.39-12-13.74-17.57-20.94a95.73,95.73,0,0,1-17.64-78.52c.79-4.67,4-9.5,8.54-12.69,3.16-2.25,7.14-3.68,10.93-2.87a12,12,0,0,1,2.26.76c2.95,1.37,5.35,4,7.42,6.62a84.22,84.22,0,0,1,17.18,40.9c.44,3.33.66,6.8-.51,10A9.6,9.6,0,0,1,121.74,361Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M698.1,840.57c.08,6.65-3.77,12.77-8.54,17.4a47.57,47.57,0,0,1-28.69,13,50.63,50.63,0,0,1-30.71-7.33,29.91,29.91,0,0,1-10.34-9.81c-2.43-4.14-3.33-9.34-1.57-13.8,3.1-7.81,12.82-10.67,21.23-10.35s16.81,2.72,25.06,1.14c7.73-1.49,15.51-6.42,22.88-3.7C692.42,829,698,833.93,698.1,840.57Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433,1319.81c-25.43-78.47-71.66-147-118.6-215.38l-.31.22c-10.36,10-15.28,18.79-20.23,32.34-9.87,27.11-9.06,57-5.09,85.54,8.06,58,28.4,113.47,48.62,168.43q12.24,33.24,24.46,66.5l85.33.12h28.15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M606.75,774.2a8.15,8.15,0,1,1-8.07,8.25A8.15,8.15,0,0,1,606.75,774.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M730.37,730.69c.76,2.42.25,5.38-1.76,6.88s-5.13,1.16-7.46-.05-4.19-3.11-6.38-4.54c-4.18-2.75-9.29-3.75-14.28-3.83a27.11,27.11,0,0,1-5.49-.37,6.28,6.28,0,0,1-4.35-3.11c-1.16-2.4.09-5.41,2.18-7.09s4.79-2.29,4.78-1.84a35.72,35.72,0,0,1,28.26,8A13.75,13.75,0,0,1,730.37,730.69Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.78,643.6c-19.08,11.8-43.73,16.42-67.66,17.29-14.86.52-29.71-.23-44.54-.91-6.74-.3-14.1-1.4-20.79-.86-5.5.44-45,6.73-70.49,47.07-.88,1.37-1.8,2.69-2.66,4.07-16.28,26.32-23.21,59.42-15,89.25a4,4,0,0,1-1.05,3.59,8,8,0,0,1-3.34,2,12,12,0,0,1-7.61.33,7.48,7.48,0,0,1-5.13-5.36c-4.55-7-11.79-12.25-19.77-13.53a25.3,25.3,0,0,0-8.68.11c-.84-1.73-1.67-3.45-2.5-5.18-16.37-39.64-24.09-85.19-4.31-121.79,15.47-28.63,45.22-46.81,75.63-58.4s62.69-17.89,92.78-30.26c19.09-12.55,41-24,64.66-25.46a84.21,84.21,0,0,1,43,8.79c6,3,11.66,6.78,16,11.81,8.91,10.15,11.82,24.77,9.16,38s-10.38,25.09-20.25,34.3A75.91,75.91,0,0,1,725.78,643.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.36,848.15c-11.2,4.7-25,3.33-34.71-4.08-11.93-9.12-16.65-26.53-11-40.4a29.81,29.81,0,0,1,6.73-10.17A26.33,26.33,0,0,1,459,786.61a25.3,25.3,0,0,1,8.68-.11c8,1.28,15.22,6.51,19.77,13.53a7.48,7.48,0,0,0,5.13,5.36,12,12,0,0,0,7.61-.33,8,8,0,0,0,3.34-2,4,4,0,0,0,1.05-3.59c-8.19-29.83-1.26-62.93,15-89.25.86-1.38,1.78-2.7,2.66-4.07,25.5-40.34,65-46.63,70.49-47.07,6.69-.54,14.05.56,20.79.86,14.83.68,29.68,1.43,44.54.91,23.93-.87,48.58-5.49,67.66-17.29l16.05,58.46c20.54,74.86,24.81,133.06,12.19,173-7.28,23-20.17,39.93-38.8,50.48a162.5,162.5,0,0,1-67.46,20.24,160.36,160.36,0,0,0,5,17c2.07,5.85,4.59,11.75,9,16.09.47.46,1,.89,1.49,1.32-15.18,19.05-41.48,27.34-65.69,24.32-24.5-3.08-46.83-16.4-64.62-33.53l-1.48-.35c.86-5-.55-10.26-2.07-15.18-11.27-36.88-27.45-72.05-43.58-107.07ZM728.61,737.57c2-1.5,2.52-4.46,1.76-6.88a13.75,13.75,0,0,0-4.5-6,35.72,35.72,0,0,0-28.26-8c0-.45-2.7.17-4.78,1.84s-3.34,4.69-2.18,7.09a6.28,6.28,0,0,0,4.35,3.11,27.11,27.11,0,0,0,5.49.37c5,.08,10.1,1.08,14.28,3.83,2.19,1.43,4.06,3.31,6.38,4.54S726.5,739.13,728.61,737.57Zm-9.41,43.54a8.15,8.15,0,1,0-8.07,8.23A8.16,8.16,0,0,0,719.2,781.11ZM689.56,858c4.77-4.63,8.62-10.75,8.54-17.4s-5.68-11.55-10.68-13.4c-7.37-2.72-15.15,2.21-22.88,3.7-8.25,1.58-16.68-.83-25.06-1.14s-18.13,2.54-21.23,10.35c-1.76,4.46-.86,9.66,1.57,13.8a29.91,29.91,0,0,0,10.34,9.81A50.63,50.63,0,0,0,660.87,871,47.57,47.57,0,0,0,689.56,858ZM617.85,726.48c1.1-2.42-.21-5.41-2.34-7s-4.84-2.18-4.82-1.73a35.73,35.73,0,0,0-28.07,8.59,13.63,13.63,0,0,0-4.37,6.08c-.71,2.44-.13,5.39,1.92,6.84s5.15,1,7.44-.22,4.13-3.19,6.29-4.68c4.11-2.84,9.2-4,14.19-4.14a26.43,26.43,0,0,0,5.48-.5A6.31,6.31,0,0,0,617.85,726.48ZM615,782.27a8.15,8.15,0,1,0-8.05,8.23A8.15,8.15,0,0,0,615,782.27Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1528.42,
    cy: 732.69,
    r: 35.13,
    transform: "translate(-97.63 254.29) rotate(-9.22)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1627.45,737.24c-12.16,6.21-24.35,12.19-37.48,19.81-7.37,4.26-14.82,8.61-20.81,14.64-13,13.15-18.29,33.43-33.59,43.77l-.06-.09c17.12-11,12.09-49.29-11.23-85.37s-56.1-56.4-73.21-45.34c10.7-9.87,26-10.15,40.45-12.35,36.11-5.49,67-27.77,98.15-46.89,7.65-4.68,15.93-9.37,24.89-9.11,9.56.26,18,6.12,25.06,12.58,13.81,12.69,33.19,41.05,33.54,72.83-.68,7.73-5,12.09-12.81,17.07-8.36,5.29-16.39,9.79-24.34,14C1633.15,734.29,1630.3,735.76,1627.45,737.24Zm-17.77-6a5.56,5.56,0,0,0-5-9.91l-19.83,10.07a5.56,5.56,0,0,0,5,9.91Zm-9.86-24a5.56,5.56,0,1,0-5-9.91L1575,707.36a5.55,5.55,0,1,0,5,9.89Zm-14.17-21.35a5.56,5.56,0,0,0-5-9.91L1560.78,686a5.56,5.56,0,0,0,5,9.91Zm-15.75-19.67a5.56,5.56,0,0,0-5-9.91l-19.82,10.07a5.55,5.55,0,0,0,5,9.91Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1612.12,723.79a5.56,5.56,0,0,1-2.44,7.46l-19.82,10.07a5.56,5.56,0,0,1-5-9.91l19.83-10.07A5.56,5.56,0,0,1,1612.12,723.79Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1602.26,699.72a5.57,5.57,0,0,1-2.44,7.48l-19.82,10a5.55,5.55,0,1,1-5-9.89l19.81-10.07A5.57,5.57,0,0,1,1602.26,699.72Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1588.09,678.39a5.56,5.56,0,0,1-2.44,7.46l-19.83,10.07a5.56,5.56,0,0,1-5-9.91l19.83-10.07A5.57,5.57,0,0,1,1588.09,678.39Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1572.33,658.7a5.54,5.54,0,0,1-2.43,7.48l-19.83,10.07a5.55,5.55,0,0,1-5-9.91l19.82-10.07A5.55,5.55,0,0,1,1572.33,658.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874.74,1226.3q-3.07-12.83-6.14-25.73c6.84-122.78,68.78-324,67.29-449.42s-21.35-218.6-56.62-339a62.8,62.8,0,0,1-1.63-6.37,278.81,278.81,0,0,1-97.75-6.68l-.7-.18c13,104.47,11.74,209.72,3.45,314-4.37,54.81-10.9,110.24-27.58,162.36a380.44,380.44,0,0,1-16,41.76c-12.74,28-31.38,56.1-60.3,66.33-5.17,2-11.14.23-15.51-3.25-15.18,19.05-41.48,27.34-65.69,24.32-24.5-3.08-46.83-16.4-64.62-33.53l-1.48-.35c-.06.38-.14.76-.23,1.14-1.31,5.39-6.52,10.23-12,9.15l-.57.17c-66.38-37.72-93.38-79.93-125.13-132.35S339,739,317.78,681.54q-46.41-125.79-83.59-254.75l-.45.13c-36.92,10.87-70.59,19.1-108.7,19-.22-1.11-.46-2.23-.75-3.34.82,7.41,16.68,359.3,97.26,514.47,26.68,51.37,60,99.37,92.89,147.38,46.94,68.42,93.17,136.91,118.6,215.38v.17l0,0,42.28,137.58,82.67.16,372.36.51v-.53Q902.58,1342,874.74,1226.3Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1229.81,
    cy: 1310.13,
    rx: 37.23,
    ry: 33.45,
    transform: "translate(-564.03 1205.29) rotate(-43.47)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M647.21,983.68c-1.37-.16-3,.64-4.15-.85-1,1.44-2.45.76-3.84.84l-1.21-1.8.92-.93a5.21,5.21,0,0,1,2.05.54c.49-.18.31-.53.18-.51a7.5,7.5,0,0,0-1.3.4c.56.16,1.11.32,1.12.11-1.22-.79-1.32-1.05-1.43-1.31-.2.26-.41.52-.62.77l-.92.93h-2.17a23,23,0,0,0-1.81-3.46,2.31,2.31,0,0,1,.25-3.51l-2.44-3.2c-.21,2-.33,3.15-.48,4.61h-2.61a5.28,5.28,0,0,0-1-.85c.22-1,.48-1.85.75-2.77h-4.94l-1.26,1.39.45.51,2.56-1.15a26,26,0,0,0,2.44,2,5.28,5.28,0,0,1,1,.85c.6,2,2.45.15,3.46,1.29.25.86.55,1.93.73,2.53-.32.71-.64,1.41-1.09,2.43l-2.57-3.5-1.16,1-2.72-3.65c-.76,1.15,0,3.67-2.91,3.56-.1-.76-.22-1.59-.33-2.35l-3.59-1.34c.31-1.09.61-2.18.91-3.26-2-1.56-3.64.78-5.41.43a30.38,30.38,0,0,1-4.75-1.79v-3l-1.27,1L604.69,968v-1.05c1.78-.45,3.6-.78,5.42-1.11l-2.58-1.94,1.42-2-4.26,1.8v3.22a2.26,2.26,0,0,1-.76.43l.76.62-.9,3.27.52-.52c.24.68.47,1.36.84,2.4.44-1.31.63-1.84.92-2.7l3.25,1.26-2.54,2.08c.26,1,.47,1.75.69,2.54-.87-.1-1.92.07-2.59-.35-1.63-1.05-3-.78-4.53.22-1.14-.77-1.21-2.81-3.11-3.1.32-1.7.65-3.4,1-5.1.31-.3.62-.61.63-.92,1.37-.41,2.47-.66,3.56-1,.14,0,.18-.4.26-.58l-2.38-1.13a15.62,15.62,0,0,0-1.44,2.68c0,.31-.32.62-.63.92h-1.85v-2.53h-5.91l-3-3.76-1,.91-4.62-3.08L585,958.4a7.44,7.44,0,0,1-.64-1.54,8.84,8.84,0,0,0-.63-2.68c.15-.06.59.4,1.3,1.15.07-.87.12-1.46.18-2.16-.74.06-1.14.09-1.48,1,.1,1.14-.39,1.43-1.19,1.9-2.5-2.78-6.36-2.58-9.92-3.54l-.73,1.56h-1.28c-.06-.81-.12-1.65-.16-2.17l4.4-2.14.72.57c.16-.32.33-.64.68-1.29-2-.81-3.64-2.76-5.94-.07l-2-2.62c1.51-1,4.16-.21,3.91-3.2-1.62-.93-3.54,2.53-5.1-.38l-.54,1.77-2.72.57a6.09,6.09,0,0,1,.45.49L562,948l.59.59h-4.16c.21-.79.41-1.59.71-2.73l-2.4.69L555,943.42l3.48,1.43,2.25-1.13c.3.7.56,1.3.86,2,.54-1.28,1.06-2.51,1.65-3.89l1.24,1.14,1.35-1.36-4.95-1.8,1.53-2.34c1.25.58,1.75,2.33,3.51,1.86,1.14.92,1.14.92,2.68.06-1,0-1.89,0-2.68-.06-1.21-1.38-2.35-2.7-3.71-4.28l-2.09,3.17h-3.3l-.43-2.6-1.28.75c-1.87-1.09-1.17-2.91-1.29-4.5l4.19-.76,1,.65c.12-.25.39-.57.33-.76a11.5,11.5,0,0,0-.8-1.51c.17-.1.5-.43.66-.37,4,1.57,7.92,3.2,11.9,4.75,1.86.73,3.78,1.31,5.65,2a37.16,37.16,0,0,0,5.34,1.66,101,101,0,0,1,10.33,2.92,25.32,25.32,0,0,0,7.19,1.65c2.69,0,5.14,1.55,7.9,1.4.54,0,1.1.38,1.66.4a20.24,20.24,0,0,1,6.13.84c1.87.66,4,0,6.11.9,1.51.68,3.56.13,5.76.13-.56.69-.8,1-1.22,1.53l1.56.41.65-1.84H639l-.95,1.34,2.43.87.32-1.31-1-.46c.53-.76,2.3-.77,6.46-.07-.63.34-1.25.66-1.85,1-.07,0,0,.29,0,.87l2.55.66.58,1.66,1.06-1c4.13,14.59,7,21.33,12.51,27.72-.31.61-.64,1.24-1,1.87l-2.43-1.15c-.15.66-.4,1.11-.31,1.47s.54.7.84,1.07a4.36,4.36,0,0,1-.9.92c-1,.56-2,1-3.08,1.59-1.05-2-2-3.91-3.05-6l-1.76,1,2.61,2.83c-.46.68-.78,1.13-1.09,1.58l.87.88-2.74,1.9c0,.56-.12,1.28-.2,2.11H646.7c-.12-.23-.39-.52-.34-.73.25-1,.59-1.9.85-2.89l.14.13.75-.64-.29-.29A5.39,5.39,0,0,0,647.21,983.68Zm-3.56-9.31-.19.18.65.75.29-.29a1.47,1.47,0,0,0-.92-.45l.18-.18-.65-.76-.29.29A1.5,1.5,0,0,0,643.65,974.37Zm-44.9-3.75c.63.71.81,1,.94,1a8.49,8.49,0,0,0,1.3-.4c-.56-.16-1.11-.32.72.4l-.8,0c.12.61.24,1.21.35,1.81l.6-.08C601.81,972.84,601.76,972.25,598.75,970.62Zm40.45,7.58c1.4.19,2.17-.73,2.54-2-.23-1.22-2.37-.36-2-2.1,0,0-1.07-.32-1.88-.57a26,26,0,0,0,1.91,5.31l-3.68-1.49c.08.7.13,1.21.2,1.82A4.8,4.8,0,0,0,639.2,978.2Zm-53.76-24.91c3.43,1.8,4.06,2.76,3.33,4.24l-1.59.58c.09,1-.72,2.26.93,2.54,2.47-2.14,1.61-4.81,1.79-7.36Zm27.81,16.78,2.16,1.61,1.16-2.48L615.31,968Zm34.94,8.79v-.46h-1.85v.46Zm-52-17.51c0-.27-.07-.53-.1-.8l-1.51.36c0,.15,0,.29.07.44ZM593.36,955h-.47v1.85h.47Zm28.92-8.1v.46h1.85v-.46Zm-18.82,16.43h-.31v.92h.31ZM601,968.29v.31h.93v-.31Zm20.36,0v.31h.93v-.31Zm-3.7.93v.31h.92v-.31Zm17.89,6.17h.31v-.93h-.31Zm17.89,0h-.31v.92h.31Zm-90.38-42.88v-.31h-.93v.31Zm8.94,5.86h-.3v.93h.3Zm6.48,4.63h-.31v.92h.31Zm-3.08,3.7h.31v-.93h-.31Zm58.92,1.23v.31h.92v-.31Zm-12.34.62h-.31v.93H622Zm-44.73,2.78h.31v-.93h-.31Zm47.81-.62V951H626v-.31Zm23.76,2.47h-.31v.92h.31Zm-3.4,2.47v-.31h-.92v.31Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.9,358.12h2.77c0,1.26,1,.76,1.64.94a17.17,17.17,0,0,1,2,.83v-4.32a20,20,0,0,1,2.37.72c.83.37.15,2.2,1.93,1.91.69-.12,1.53.67,2.4,1.09l-2.12,2.24.83,3.5L150,362.29l-4.95.65c-2.13,1.35-1.1,3-.23,4.65l-3.15,2.28,1,1.48c-.69,1.72-1.38,3.41-2.17,5.37l-2-1.12c.89-1.73,1.7-3.33,2.54-5l-2-2.1,2.3-1.72c-.39-.67-.67-1.17-1-1.66l1.32-3.63c-.22-.85-.43-1.66-.63-2.47C141.75,358.9,142.82,359.5,142.9,358.12Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.52,343.31c-.3.93-.6,1.85-.93,2.9l-4.77-3.75c.34-.55.71-1.14,1.23-2-1.31-1.7-3.16-3.22-3.86-5.48l2.64-.67a5.59,5.59,0,0,0,.16,1.47c.55,1.67,1.48,2.48,2.94,1.87,1.05-.45,1.67,0,2.52,0a8.55,8.55,0,0,0,2.85-.84l.6,1.29c-.22.85-.48,1.87-.78,3.05l3.88,1.21q.42.74.84,1.44l-1,1.16h4.94c1.38,1.07,2.21,2.07,1.3,4L876,348l-.38,2.63h-1.54v-3.49l-3.83-3.83h-2.77c-.31-.31-.62-.62-.85-.88.07-.93.07-1.79.07-2.61l2.68-.88-3.27-.32c-.73.75-1.52,1.58-2.33,2.43l2.85,1.38C866.9,342.69,867.21,343,867.52,343.31Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M879.67,341l3.89-1.41,1.93,3,.93-2,1.64.14-.87,2.23,1.78,1.21c-.75,1.59-2.75,1.25-6.31-.7L881.08,345l-2.55-1.22C878.92,342.83,879.33,341.82,879.67,341Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M844.76,342.27c-1.25,0-2.12,0-3,0-.56-2,1.37-2.23,1.91-3.33l3.71,1.17c-.42.85-.8,1.61-1.23,2.46l1,1.45-2.81,1.75,1.32,3.49-4.05-1.59v-2.8a24.94,24.94,0,0,0,3.12-2.56c-.41.09-.35.15-.29.21l.75-.64-.29-.3C844.72,341.8,844.5,342.05,844.76,342.27Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.37,347.94h3.4c.11,3.44.82,6.91-1.18,10.25-1.51-1.69.45-2.81.46-4.42l-2.68-.45Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.05,359h-1.56c-.15.81-.31,1.65-.5,2.64h-3.53c.32-.49.56-.84.86-1.28l-.91-1,2.77-1.83-.92-.91a5.55,5.55,0,0,0,1.45-.41,8.58,8.58,0,0,0,1.28-1.15l1.59,1.06,1.32-1.06v3C142.19,358.26,141.12,357.66,141.05,359Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.41,371.45c-.22-.26-.49-.58-.74-.86l.68-.81c-.34-1.79-.62-3.32-1-5.31l4,3.45-1.9.64c.32.45.6.86,1,1.44l-.9,1.68,1.87.75-1.17,2.14h-4.14Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M887.56,348.1c.35-1,.53-1.53.75-2.17.52.2,1.06.24,1.28.53.72.91,1.31,1.91,2.3,3.4l-3.77-1.1-4.47,2.31,2.8,1.72-1.89,1.41c-2.85-1.05,0-4.45-2.7-6.1Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M851.79,337.76c.75-3.15,1.51-3.45,4.62-1.85l-1.86,1.46,3.73,1.69c0,.72-.09,1.55-.16,2.74l-2.63-1.27C855,338.59,853,338.73,851.79,337.76Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.74,357.19h4.1l3,3.15L176.7,362l-5-2.79Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.35,358.45l.61,2.4c-.64.46,1.14,1.32.86,2.25l-3.52,2.34-1.05-1.38.71-.71-.82-1.61Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.63,349.59l-5.43,1.82-1-1v-2.51l3.44.58,2.5-2C867.34,347.89,867.5,348.83,867.63,349.59Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M873,337.25l2.53-1.81c.57,2.45,1,4.5,1.63,6.94a18.41,18.41,0,0,1-2.19,0c-.32,0-.83-.22-.89-.44C873.65,340.53,873.37,339.12,873,337.25Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.4,355.34c.22.79.44,1.59.62,2.27l-4.91,3.83c-.14-1.45-.24-2.38-.33-3.32l.92-.93,1.46-1.85Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M855,340.54l2.47,3.95c-.26.56-.57,1.19-.83,1.84s-.37,1.05-.57,1.63l-1.69-.22c.41-1.05.76-1.92,1.2-3.05l-1.88-.8v-3.24Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M596.62,969.14l-5.19,2.54-1.3-1.09c-.3-.83.79-1.42,3.19-1.71.17-.88.35-1.83.54-2.84C596.11,966.28,595.51,968.34,596.62,969.14Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M619.08,976.31c-.59,1.05-.88,1.52-1.12,2s-.28.8-.46,1.33l-2.88,1.42-1.1-1,3.68-3.74Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.1,368.09c-2.4,1-4.4-2.24-6.48.25L124.89,366c1.89-.75,3.32-.81,4.61.28l1.72-1.12C131.91,366.25,132.49,367.16,133.1,368.09Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M881.26,356.38l-3.1,1.05L877,353.51l3-1.35C880.4,353.58,880.72,354.64,881.26,356.38Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.2,368c2.31,1.1,3.87,2.18,3.42,4.86h-1.91L153,370.32C153.28,369.8,153.65,369.05,154.2,368Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M573.21,957.4c.06-1.06.13-2.19.21-3.44,2.39.35,2.87,2.53,4.57,3.25l-1.63,1.63Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M892.13,340.55c-2.71,0-2.19-2.7-3.63-3.77l1.41-1.54C891,334.73,892.35,337.88,892.13,340.55Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158,361.47l2.09,1.19,1.91-1.91,1.13,2.21c-.15.22-.63.93-1.13,1.65l-4.33-1.29C157.77,362.83,157.86,362.3,158,361.47Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131,361.56l-3.17-2.08,6.59-1.32c-.11.62,0,1.46-.37,1.76A17.89,17.89,0,0,1,131,361.56Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M873.19,356.49l-2.22-1.7,1.41-4c2.71,1.26,1.1,3.5,1.76,5.16Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M870.41,336.85c-.64-1.16-1.25-2.25-1.89-3.43,1.91-1.06,3.08.7,4.68,1.13C872.71,336.14,871.94,337.06,870.41,336.85Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M566.6,946.85V950c-1.39.19-2.56,2.25-4.9.66Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M851.79,337.76l-.93,2.77c-2.48-.67-2.48-.67-2.62-3.39C849.63,336.12,850.64,337.32,851.79,337.76Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M555.27,939.45H558c-.51,1.65,3.33,1.22,2,3.57C557,941.86,557,941.86,555.27,939.45Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M588,967.67l-4.59-1c.05-.46.1-.87.18-1.66l2,.72,3.79-.8Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M553.22,931.88l-1.67-2.18,4.58-1.54c.19.36.31.61.52,1Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M892.54,345.08h-2.62c-.53-1.85-.09-3.11,2.33-3.79Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.72,366.93v-1.39l2.51.66,1.87-1.12c.11,1.24.19,2.06.26,2.83-.44.18-.75.43-1,.36C160.15,367.86,158.92,367.38,157.72,366.93Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M857.34,351.92l-3.92-1.2c2.47-2.39,2.48-2.43,4.82-.49-.3.32-.62.62-.89,1C857.28,351.29,857.34,351.49,857.34,351.92Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.72,368.3h1.61v6.3l-1,.22c-1.85-.89,1.32-2.37-.52-3.21C134.47,370.47,133.26,369.39,132.72,368.3Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M580.35,964.9l-3.07.36c-.25-.67-.42-1.22-.66-1.73a3,3,0,0,0-.59-.66l1.41-1.41C578.29,962.45,579.12,963.44,580.35,964.9Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M857.14,350.77l3.47,2.6-2.9,2.73C857.5,354.16,857.37,352.91,857.14,350.77Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M873.32,349.47c-2.25.71-3.43.12-4-1.75C871.58,346.92,871.58,346.92,873.32,349.47Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M115.94,365.48l3.44,2.77-3,2.65C116.22,369,116.12,367.85,115.94,365.48Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175,354.31l-3.27-1.91,1.44-2.92,2.37,4.36Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M868.07,358.89l1.76-4.55c.78,2,1.21,3.12,1.77,4.55Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M851,340.86l2.25,1.23A17.48,17.48,0,0,1,851.5,344c-.28.22-.79.15-1.21.22C849.54,342.78,849.73,341.58,851,340.86Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.75,354.05l1.28,2.59c-1.61,1.18-2.69.58-3.82-1Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M853.34,356.3l-3.17,2.36c-.12-1.33-.2-2.14-.26-2.83l1.22-1.22Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M886.32,357.16l3.18-2.36c.12,1.33.19,2.14.25,2.83l-1.22,1.22Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M852.77,364.36l3.52-2.86v2.86Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M888,336.49l-1.61.62.37.5h-5.2l-.06-.44,6.12-1.33C887.76,336.06,887.88,336.28,888,336.49Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.81,350.71c.07,1.58.2,3.19-1.85,3.71l-1-1.78A2.37,2.37,0,0,1,168.81,350.71Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.52,333.38v2.34l-2.62.24v-2.58Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.33,365.23l2.28-1.47,1.26,3.37C95.89,366.94,95.89,366.94,94.33,365.23Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M875.64,362.39v3.5l-2.2-1.3Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.47,974.46v2.6h-2.7C590.9,975.07,591.89,974.38,593.47,974.46Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.21,347.94h-2.77v-1.85l2.51-1.28C176.05,346.07,176.13,347,176.21,347.94Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.67,358.16c0-.81,0-1.58,0-2.35,0-.46-1.2-.51-.5-1.41,2.26.14,2.51,1.58,2.31,3.6Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M550.88,941.53v3.18l-2.53.18C548,943,549.15,942.52,550.88,941.53Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M852.11,349.63h-3.37c.58-1.09,1-1.89,1.62-3.05C851,347.72,851.47,348.51,852.11,349.63Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M607.63,975.82l2.86,1.86-2.86,1.77Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M626.46,986.26l2.94-2.2c.09,1.47.15,2.38.24,3.74Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M627.35,986.73l-2.94,2.2c-.1-1.47-.16-2.38-.24-3.74Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.39,365.17l2.63-2.09c.2,1.41.32,2.28.54,3.83Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M548.47,937.94l2.73,1.74-2.73,2Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M839.68,337v1.54h-2.62V337Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M585.34,977v-3.24l2.82,1.13Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.84,974.51,592.7,973l1.37-1.38L596,974Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M842.22,356.11l1.38,2.46c-1.76,1.07-2.14-.25-2.86-1Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M587,971.6h-1.53v-2.67C588,968.84,586.87,970.46,587,971.6Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M540.76,929.9v2.73l-1.6.31c-.07-.92-.14-1.75-.21-2.68Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.52,349.79h1.41c.41.82.82,1.66,1.39,2.83C868.26,352.44,867.43,351.57,867.52,349.79Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M556.72,952.42,555,954.31l-1.91-3.51Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.79,373.09v1.52h-2.67C103,372,104.65,373.17,105.79,373.09Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M839.6,358h-1.54v-2.62h1.54Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.91,329.52,176,327.9l3.56-1.9C178.7,327.8,178.34,328.6,177.91,329.52Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M635.08,986.32l1.68-1.88c.51.92.94,1.72,1.92,3.51Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M543.77,925.32l1.93,1.62-3.56,1.91Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M546.92,939.22h-3.4l.58-2.33Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.35,363.82c-.13.7-.22,1.21-.38,2.14L172,363.82Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M548.69,931.88c.53.53.86.85,1.18,1.19a.39.39,0,0,1,.08.23l-1.22,1.4-1.39-1.4Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M864.08,355.61c-1.12-1.57-1.54-2.15-2.09-2.91l2.88-.19C864.65,353.38,864.51,353.94,864.08,355.61Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M642.15,993.31,640,996.22V992.9Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M653.67,987.2l-3,2.52-1-2Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M632.69,986.08l2.07,2.63-2.07.81Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M583,966.28l-3,2.15c-.16-.94-.25-1.45-.37-2.15Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M562.54,955.8l3-2.13c.14,1,.22,1.46.32,2.13Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M830.05,339.58l1.28,1.39-1.27,1.44c-.48-.49-.92-.92-1.39-1.39Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M558.42,948.11v2.07l-2.64.22c-.06-.21-.12-.42-.19-.62Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.8,371.73l2.77-2.06C166.87,371.61,166.87,371.61,164.8,371.73Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154,368.33l-1.76-.13-.13-1.58,1.74-.19C154,367.19,154,367.74,154,368.33Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578.79,957.88h1.65l.26,1.37C579.47,960,578.71,960,578.79,957.88Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M574.16,959.74h1.65l.26,1.36C574.85,961.81,574.08,961.8,574.16,959.74Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M864.57,360.93l-3-.21,2-1.71C863.81,359.51,864.13,360.12,864.57,360.93Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M892.07,351.91l-2.05,2.8C890.11,352.69,890.11,352.69,892.07,351.91Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M550.08,930h-1.65l-.26-1.36C549.4,927.88,550.16,927.9,550.08,930Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.81,350.27l2.53-1.33c.11.4.21.8.39,1.51l-2.89.37Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.76,366.76l-1.66-1.67,1.66-2.08Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.78,358.12c-1.31-.25-1.25-1.1-.5-1.72.49-.41,1.4-.3,1.42.79Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M844.94,337.32l-1-2C845.12,335.07,845.12,335.07,844.94,337.32Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M881.47,366.58v-1.52l1.8,1.18Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M836.6,344.89l-2-1.22C836.89,343.5,836.89,343.5,836.6,344.89Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.18,360.62l1.23,2C121.23,362.8,120.13,363.08,121.18,360.62Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M652.78,987.42c0-.55.08-1.1.14-1.84l1.76.12-1.4,2.18Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M884.52,345.66l-2,1C882.31,345.8,881.85,344.6,884.52,345.66Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M878.45,350.56h-1.53l-.06-.46,1.54-.34C878.42,350,878.44,350.29,878.45,350.56Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.35,366.59v1.54l-.44.07-.36-1.51Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M834.9,346.09v1.85h-.47v-1.85Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M180.63,366.42l.15,1.78-.59.07-.36-1.81Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.41,370.54c.32-1.13.48-1.69.64-2.24a7.67,7.67,0,0,1,.4,1.29C160.47,369.73,160.12,369.91,159.41,370.54Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90,356.44V358l-.46.06-.33-1.54Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M645.64,993v-1.85h.47V993Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M856.41,335.91c.08-1.39,1.15-.79,1.85-.93C858.19,336.37,857.11,335.77,856.41,335.91Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M549.31,926.5h1.54l.07.44-1.51.36C549.38,927,549.35,926.76,549.31,926.5Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578,933.9h1.54c0,.15,0,.29.07.44l-1.51.36C578.07,934.43,578,934.17,578,933.9Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M582.34,935.44H580.8c0-.15,0-.3-.07-.44l1.51-.36C582.27,934.9,582.3,935.17,582.34,935.44Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M583.58,935.75h1.53l.06.46-1.54.34C583.61,936.28,583.59,936,583.58,935.75Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M591.57,938.21H590l-.06-.45,1.55-.34C591.53,937.68,591.55,938,591.57,938.21Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M825.87,335.21h1.85v.47h-1.85Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M859.35,342.24V340.7l.44-.07.36,1.52Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M139.35,379.26v-1.54l.44-.07.36,1.51Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M148.3,377.39h-1.53c0-.14-.05-.29-.07-.44l1.5-.36C148.24,376.86,148.27,377.13,148.3,377.39Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M858.26,335c.21-.25.42-.51.62-.77.11.26.21.52.31.77Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172.51,346.09c.21-.26.41-.52.62-.77.1.25.2.51.31.77Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172.61,346.17l-.65.76-.29-.3.76-.64Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M660.3,979l.76.65-.29.29-.65-.76Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M576.93,933.43H576v-.3h.93Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M588,937.14h-.92v-.31H588Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M608.09,941.15v.92h-.31v-.92Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M626.59,943v.92h-.3V943Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.65,378.17h-.92v-.31h.92Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 172.05,
    cy: 371.54,
    rx: 0.65,
    ry: 0.22
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M842.22,362.74v.93h-.31v-.93Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.31,355.26l.64-.76.29.29-.75.65Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.59,353.49v.93h-.31v-.93Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M843.15,352.56v.93h-.31v-.93Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1527.47,776.88a3.31,3.31,0,0,1-1.8.35c.28-.47.55-1,.83-1.43-.38-.39-.8-.81-1-.95l-7.44,2,2.25,1.34c-.79,1.45-2.42,2-1.94,3.62h-1.34c-1.3-4.39-1.3-4.39-.59-7.26-1.21,0-2.36,0-3.56,0l.14-.13-.63-.74-.29.29a4.93,4.93,0,0,0,.78.58c.33.87.61,1.79,1,3-1.94,1.21-.59,3.3-1.48,6.22.19.46.52.28.5.15a7.53,7.53,0,0,0-.39-1.28c-.15.55-.31,1.1-.11,1.13,1.45-1,2.37-.95,4.18-.77L1514,785c.27,1.4.54,2.73.8,4.06l-2.87,1.37.84-2.93c-.9-.76-1.21-2.16-1.83-3.38a3.36,3.36,0,0,1,.17-3.9,2.37,2.37,0,0,0,0-2.17c-1.53-1.83-.44-4-1-5.88l-2.37-1.21c-2.14.57-4.23,2-6.75,1.82-.22,0-.48.56-.71.87-2.15.31-1.42,2.54-2.45,4l-2.81-2.34,2.4-1c0-.36.08-.77.13-1.23l-2.71.58V772c-1.51.25-3,1.52-4.69.1q1.32-2.67,2.72-5.46l-1.08-1.07-3.3,1.68c-.17-1.5-1.36-.67-2.3-1l-1.61,2.16-1.43-1.67,2.48-3.77a6.13,6.13,0,0,0-5.64.85l-1.32-1.59c.23-1,3-2.51,5-2.18a32.67,32.67,0,0,1,5.19,1.68c.88-1.53,2-3.09,1.21-5.1-1.63.08-2.48,1.18-3.23,2.71l-4.46-2.82c-.11.33-.28.85-.5,1.49l-1.63.27c.27-1,.46-1.68.5-1.8-.2-1.57-.34-2.66-.47-3.75l.9-.69-.9-1.13.9-2.72c2,.39,1.67,2.29,2.16,3.75l1.07-1.08,3,3.68h1.08l.3.75a1.78,1.78,0,0,0,.45-.83c1-.07,1.87-.07,3.53-.07l-2-1.62a13,13,0,0,0-1.48,1.69,2,2,0,0,1-.75.08v-3.31a8,8,0,0,1-2.74-2.07c.92-.07,1.82-.19,3.5-.41l-3.35-1.72c-.08,1-.12,1.53-.15,2.13-1.89.64-2.26-2-4-1.91l-.48.94-1.81-.9.37-.8-2.59-2.6.51-.54c-.07-.71-.15-1.42-.24-2.27h-3.28c-.12-1.25-.23-2.38-.31-3.28l-2.54-1.59c-.38-3.68.09-6.86,3.55-9.47v-3.94h1.81v-1.71a13.26,13.26,0,0,0,1.38-1l.94.82c-.33-.38-.66-.75-1-1.13l2.36-.16-.39-.5-3.31.17v1.76c-.6.5-1.21,1.11-1.81,1.71h-2.72c.3-.6.6-1.21.86-1.85l.12.13.75-.63-.29-.28a4.51,4.51,0,0,0-.58.78c-.86-.26-1.77-.57-2.68-.87l-.9-.9c.38-.59.77-1.17,1.16-1.75,1-1,2.81,1.08,3.45-1a13.8,13.8,0,0,1,1.53,1.05c.42-1.61.41-2.87-1.46-3.65,0,.93,0,1.79-.07,2.6-1-.25-1.91-.55-3-.91.55-.66.81-1,.78-.92-.31-.63-.61-1.24-.8-1.65l-1.73.95c-1.71-1.14-2.07-3.59-4.36-3.77v-1.82l.91-.9h2.72v3.33l3,1.25c-.43-1.09-.7-1.79-1-2.58l4-2.68,1.31.73,1.89-1.34-1-1c.93-1.11,2.62-2,1.45-4-.31.25-.56.6-.89.69a12.75,12.75,0,0,1-2,.24c-.48-.72-1-1.49-1.54-2.3l2-.92c0-.16,0-.32-.08-.48h-2.58V696.2l3.24-2.26h3.16l-3.1,1.72c1.57,1.84,3.65,2.47,4.24,4.78.76-2.51,3.61-2.59,4.28-4.84-.29-.56-.61-1.18-1-1.84l.13.14.74-.63-.29-.29a4.93,4.93,0,0,0-.58.78c-.52,0-1.08,0-2,0l1.46-3.52h1.6l3.53,3.1-1,1,1.83,1c.07-.92.15-2,.22-3.12.24-.1.37-.21.45-.17s.2.21.32.3a93.86,93.86,0,0,1,14.27,12.51c.33.36.26,1.1.43,2-3,.44-3.44,3.49-5.17,5.3s-2.54,4.34-4,7v2.36l-1.62,1.27c-.44,3-.93,5.37-1.12,7.81s0,4.82,0,6.9c1.66,3,3.09,5.84,2.71,8.9,1.22,1.71,2.76,3.09,3.3,4.78,1.11,3.49,3.93,4.93,6.67,6.58l-.67.68,4,3.29.83-.83c2.29,3,5.57,4.11,9.14,4.64.86,1.61,2.74-1.49,3.46.75,1.5,0,3,.06,4.5.07s2.72.09,4.07,0,2.75.19,4.25-.72,3.58-.75,5.53-1.08l3.08,11.66-2.17.17-2.36,2.79s-.07.67-.17,1.53l-3.14.46,2.58,1.65c-2.08,2.23-.49,4.61-1.31,6.51l1.78,1.77v3.38h-1.33c-.45-1.22-.94-2.52-1.58-4.23-.88-.49-2.64-.9-2.32-3h1.65c.06-1.08.13-2.18.21-3.59l-3.47-1.4c-.07-.14-.34-.75-.79-1.74-.25,1.29-.42,2.22-.61,3.18-3.35-.27-1.67-4.36-4.25-4.85a8.64,8.64,0,0,0,.9-1.93c0-.09,0,.17,0,.43l1.76-.34c0-.2,0-.39-.08-.59A3.22,3.22,0,0,0,1527.47,776.88Zm-47.22-41.27.17-.17-.63-.74-.29.28c.25.21.5.42,1.21,0-.51,1.33-.81,2.09-1.2,3.09l3.09,1.55C1481.79,737.68,1481.34,736.57,1480.25,735.61Zm6.22-28.23-.78,0,.35,1.77.58-.07a1.8,1.8,0,0,0-1.1-1.71l1-5.27-2.42,2.15.84,1.29-1,1.83C1484.73,707.41,1485,707.41,1486.47,707.38Zm-10.68,28.84c0-.72.19-1.36,0-1.57a10.93,10.93,0,0,0-2.42-1.13c1.18,2.08,2,3.42,2.65,4.64l2.8-1.41c-1.06-.19-1.87-.34-3.08-2.22l.18.18.74-.64-.29-.28C1476.12,734,1475.91,734.28,1475.79,736.22Zm29.1,28.22-.17.18.63.74.29-.29a2.56,2.56,0,0,0-.83-.53c-.15-1.48-1.32-.68-2-.91-1.48.6-1.89,2.65-3.78,2.8-.19,0-.31,1.05-.47,1.62,1.18-1.16,2.44-.74,3.42-1.11v2.83l-1.69.56.12.55,3.38-.59.88.64c-.08-2.6-.08-2.6-2.54-3.67.29-.44.85-.9.83-1.33C1502.81,764.35,1503.83,764.52,1504.89,764.44Zm34.19,10.33-2.57.75-2.67,2.5c0,.35.11,1.13.21,2.11l1.16-1,1.3,1.07c.5-1.42.91-2.58,1.33-3.74l2.55-.36Zm-43.34-11.21v-.34c-1.53-1.53-2.59-2.6-3.46-3.46v3.8Zm-7-18.45-4.09-3.2-2.91,1.63,1.27,1.18,1.87-1.07C1486.29,743.86,1486.48,746.13,1488.69,745.11Zm-10.77-17.6-.55.48,1.93,2.62c-.23.29-.48.59-1.45,1.76l3.35-1.47-1.13-2.37Zm16.91,40.19c.05.88.12,2,.22,3.47l2.29-2.42Zm-16.5-55.4-1.41-1.58v4.41C1477.51,713.93,1477.87,713.22,1478.33,712.3Zm2.1-6-2,.36c.06.9.11,1.71.2,3C1479.36,708.4,1479.77,707.61,1480.43,706.34Zm16.46,56.47v2.75l1.92-.39ZM1489,699.17c-.29-.64-.58-1.26-.87-1.88l-.43.32v1.56Zm-14.38,33.14V730.9l-1.2.21Zm4.42-19.95c2.62,1,2.17-.14,2-1Zm13.57,45.57c.29-1.37.29-1.37-1.91-1.2Zm16.47,10.23h-.45V770h.45Zm-27.73-40.95.78-.1c-.12-.49-.23-1-.35-1.47l-.43.07Zm4.15,4.68h-.45v1.81h.45Zm32.57,39.9h-.3v.91h.3Zm-22.67-14.51h-.3v.91h.3Zm36,20.86h.31v-.91h-.31Zm-8.76-4.53h-.31v.9h.31Zm-34.16-72v-.3h-.91v.3Zm-5.14-1.51h.3v-.91h-.3Zm-1.21,40.2v.31h.91v-.31Zm-.6-15.71h.3v-.91h-.3Zm3-10h-.3v.91h.3Zm-2.72,0h-.3v.91h.3Zm-1.51-.3v-.3h-.91v.3Zm-8.16-3v.3h.9v-.3Zm7.55-6.65h.31v-.91h-.31Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1524.83,784.28a21.19,21.19,0,0,0,.89,3l-.13-.14-.74.64.28.28a5.7,5.7,0,0,0,.59-.78c.4,0,.86,0,1.6,0,.07.67.14,1.37.24,2.37l5.19,2.74v3.32l-2.27-1.06-3.9.79c.34-1.34.69-2.68,1.11-4.33l-3.56-.33c-.18-.49-.37-1-.56-1.54l-2.43,1.19v1.38h-2.72a13.92,13.92,0,0,1,.07-1.81c.83-.41,1.71-.87,2.71-1.4l-2.63-1.24c0,.92,0,1.78-.08,2.64-1.06.67-2,1.34-3.43,2.28-.12-1.36-.2-2.27-.27-3.19h1.82c-.46-.87-.76-1.45-1.08-2.07l2.43-1.4,1.68,1c-.53-2.09-.88-3.44-1.22-4.79,2.28,0,3.21-1.32,3.67-3.38a8,8,0,0,1,1.48-2.29l2.1,1.13c0,1.51,0,3,0,4.58l-.13-.14-.74.63.28.29a5.7,5.7,0,0,0,.59-.78,17.36,17.36,0,0,1,1.61-1c.06.85.12,1.65.18,2.38a15.57,15.57,0,0,1-2.68,1.09,32.13,32.13,0,0,0-4.47-1.35v2.15l1.16,1.15C1522.6,785.65,1523.09,784,1524.83,784.28Zm6.11,9.12c0-.26,0-.52,0-.77l-1.51.33.06.44Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1468.54,707.41c-.61-.91-1.21-1.82-1.82-2.72l3.76-1.4c-.22-.75-.47-1.54-.68-2.34s-.41-1.64-.57-2.28l-3.24.68c-.08-.72-.12-1.13-.18-1.71l2.7-.42V693.8h3.66c-.2.76-.39,1.51-.65,2.53l1.55,2v2.47l-2.43.79,3.13.6c-.4,1.24-.74,2.28-.88,2.7Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1472.12,742.82c.05,1.7.1,3.45,0,5.19,0,.39-.56.74-.9,1.16a.76.76,0,0,0,.13-.13l-.63-.74-.28.28a4.57,4.57,0,0,0,.78.59c0,.4,0,.86,0,1.31l-2.44,1.25-2-2.87V746.3l3.3.64.79-1.86c-.22-.93-.49-2.11-.9-3.85l-2.56-2,1.75-3,3.85,2.65c-.51,1.07.93,2.77-.94,4l.14-.13-.63-.74-.29.29A5.44,5.44,0,0,0,1472.12,742.82Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1462.19,685.64l.83,1.43-1.65,1.66,3.1,2-3,.47v2.57l1.65-1.07c.57.47,1.2,1,2,1.63l-1.07,2.21c0,.1,2.29,1.14,0,1.77-1.16-1.85-3.38-2.75-4.51-5.72.14-.74.47-2.34.78-3.91l-.65-.65c.4-.8.8-1.62,1.19-2.42Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1480.33,752.75l-2.45-.64-1.9.93v-3.55a9.88,9.88,0,0,1-1.65-.5,6.31,6.31,0,0,1-1.09-1.07v-3.46a8.84,8.84,0,0,1,4.22,2.18,5.41,5.41,0,0,0,2,.67c-.23.82-.45,1.65-.71,2.58l1.62,1Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1464.91,713.75l-2.92.8-2.64-1.3c.49-1.57,1.26-2.43,2.79-2.24.09.63.2,1.22.22,1.29l1.79-.68-.35-.5-1.66-.11c0-1.08.43-2.33-1-3.22l3.38-2.17,1.3,1.79-.91.9-.91.69c.31.37.61.75.91,1.13Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1492.89,775.56c.37,2.22.77,4.55,1.22,7.27l-5.2-1.57,2.1-1.8-1.72-2,1.34-2.74Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1472.17,690.18l-6.13,1.21v-4.56a13.88,13.88,0,0,1,6.13,1.1Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1523,801.72l-1.81,2.72c-.61-.57-1.77-1.18-1.72-1.68.21-2.23-1.44-2.61-2.8-3.3.42-1.65.84-3.28,1.26-4.92l1-.1c.54,2.12,1.08,4.26,1.61,6.37H1522Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1486.09,785.81l-2.57,1.16-1-.57-.85.72-1.36-1.25c.21-.86.4-1.66.62-2.57l1.88-2.32Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1464,698.34c.28.47.55.94.83,1.43l-.81.86,2.7,1.52v2.54h-2.45L1462.6,702h-2c-.07-.79-.14-1.59-.19-2.28Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1470.35,720.1c-.49.67-1,1.35-1.64,2.24l-2.2-2,.91-1.64c-1.63-.6-1.86-2.69-3.38-3.49.32-.56.6-1,.87-1.51,1.91-.51,1.94,2.06,3.46,2.13.75,1-.86,2.71,1.08,3.32Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1513.26,793.38l1.44,1.46c-1.09,2.38-3.23,4.39-2.49,7.67l-2.75.14v-2.47l1.62-.58-.89-1.4Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1462.19,726.45c-.3.22-.76.39-.88.68-.39,1-.67,2-1,3l-1.76-1v-1.4l1.83-.83-1.06-1.15,1.52-3.13,2.93.81.69-.64,1.32,1.32c-.38.4-.75.81-1.12,1.21l-2.48-1Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1529.63,798.93l1.35,1.18,3.26-2.51c.62.62,1.29,1.27,2.26,2.22-1.45.82-2.18,1.17-2.83,1.63a17.55,17.55,0,0,0-1.61,1.44l-4.08-1.66C1528.62,800.35,1529.13,799.64,1529.63,798.93Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1471.43,766l-3.57,4.26c-2.31-1.42-3.2-3.2-2.79-5.72h1.29c.16.46.33,1,.65,1.91,1.27-.33,2.57-.66,3.88-1Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1480.77,692.2c.17,1.25.31,2.27.48,3.48-2.4-1-1.71-2.79-1.84-4.33-1.45-.71-3.51.53-4.41-1.88l2.36-1.35,4,2.67C1481.17,691.21,1481,691.72,1480.77,692.2Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1499.37,780.86l2.3-1.2.91,2-1.37,1.46,4,1.41-2.47,2.32c-.42-1-.65-1.6-.91-2.22-1.36-.22-2.93-.17-3.38-2C1499.82,782.6,1499.23,781.55,1499.37,780.86Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1465.89,732c.78,0,1.64,0,2.57,0v1.35l-5.09,1.17c-.12-.26-.42-1-1-2.29.2-1.87.2-1.87,3.35-2.06,0,.56.1,1.12.18,1.8a.6.6,0,0,0-.15-.21l-.75.63.29.28Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1472.07,725.57c-.58,1.83-1.15,3.66-1.69,5.35l-2.44-1.43,2.4-.48-2.54-4.08,2.58-2.59,2.26,2.33Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1498.46,782.67H1495v-4.6l4.36,1.37v1.42C1498,780.94,1498.6,782,1498.46,782.67Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1539.8,778.81l2.71,1.35.8-2.29c.67,1.64,1.19,2.93,1.79,4.39l-5.47,1.48c-.15-.24-.31-.47-.47-.7l2.64-.61-.9-.93Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1522,800.81c.88-3.1,2.33-4.84,4.54-5.44l1,1.89-4.62,4.46Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1485.77,778.14l1.06-.59-1.38-2.73,3-.43c-.17,1.26-.31,2.28-.49,3.63.14.47.41,1.39.78,2.67l-3.93.21v-1.85Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1464.65,738l2.62,1.94-2.19,1.42c-.06.4-.2,1.22-.37,2.2l-2.38-1.16C1461.57,740.45,1463.25,739.55,1464.65,738Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1468.09,755l-2.16.77c.15.18.31.35.47.53h-3L1462,753.2c2.3-1.54,3.63,1.66,5.77,0C1467.88,753.83,1468,754.42,1468.09,755Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1505.3,778.4c-.53-1.59-1-2.91-1.41-4.28l1.5-1.58,1,1.75-.92,1.07h3.83c-.21.52-.23.82-.38.92C1507.75,777,1506.55,777.67,1505.3,778.4Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1502.16,802.2v-2.84l3-1.44,2,2.35Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1514,804.68c1.65-.66,2.7-.06,3.62,1.45l-.86,1.46c.24.43.46.8.67,1.17C1515.08,808.19,1513.42,807.2,1514,804.68Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.17,699.29v-3.44c1.85-.9,1.45.84,2,1.48l1.59.16-2.4,2.4Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1470.75,762.66h-4.61c1-2.26,1.2-2.57,2.8-3.67Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.16,699.69l-2,.87.57.61c-.35.69-.69,1.34-1.16,2.25l-2.24-2c.2-.46.26-1,.55-1.17.87-.68,1.83-1.24,2.77-1.85Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1540.21,798.12l-3.1,1.12c-.5-1-.88-1.74-1.43-2.83l3-1.32Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1458.5,708.37l-2.11-1.6,1.68-2.13c.37.38.69.7,1.1,1.1l.82,4.09-2.57,1.34C1457.85,710.05,1458.11,709.36,1458.5,708.37Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1478.1,773.59a2.68,2.68,0,0,1-3.32-2l2.24-1.48,2.25,1.05C1478.89,772,1478.49,772.78,1478.1,773.59Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1502.25,790.12c-.47,2.27-1.64,2.9-3.52,2.37-.74-1.73-.07-2.8,1.52-3.55Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.83,733.93c-2-1.33-1.91-2.89-1.53-4.65h2.18C1455.73,731.65,1455.68,732.08,1454.83,733.93Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1478.51,766.53c.42-.31.74-.59,1.09-.8a8.94,8.94,0,0,1,1.09-.4c.52,1,1.08,2,1.71,3.25a6.43,6.43,0,0,1-1.32.48C1479.17,769.18,1478.43,768.14,1478.51,766.53Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1497.74,795.64c-.67.68-1.09,1.1-1.41,1.41h-2.5a9.78,9.78,0,0,1,.56-2.53c.61-1.15,1.32-1,2,.1A4.84,4.84,0,0,0,1497.74,795.64Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1523.86,807.16l-2.3,1.2-.91-2c.08-.3.28-1.09.49-1.88C1523.17,804.63,1523.67,805.13,1523.86,807.16Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1535.76,807.56l-1.54,3.68c-.94-.85-1.69-1.54-2.71-2.48l3.57-1.77Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1453.59,736.56h3.92c0,.65.11,1.46.18,2.28C1455.62,739.67,1454.61,738.79,1453.59,736.56Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1468.82,682.75l6,1.25v1.34a2.59,2.59,0,0,1-3.16-.57,10.62,10.62,0,0,0-3-1.35Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1500.28,773l2.62,1.7v2.75l-2.62-2.62Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1460.38,742.18l2.08,2.6c-1.64,1.41-3.19.2-4.38.8C1458.81,744.5,1459.48,743.5,1460.38,742.18Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1507.88,797.09c-.12-.27-.39-.58-.32-.77a10,10,0,0,1,.73-1.36l-1.06-2.12h3.24C1509.66,794.47,1509.56,796.19,1507.88,797.09Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1477.14,755c.26.9.52,1.81.83,2.87l-1.85,1.07-1.09-1.09c.39-.78.79-1.6,1.19-2.42Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1488.49,786.51l2.88,4.19h-2.51C1489.16,789.5,1486.66,788.84,1488.49,786.51Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1473.32,774.34l-3.73,1.45V773C1471,771.91,1472.07,772.93,1473.32,774.34Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1465.15,682h2.3c.07.78.14,1.59.23,2.57h-2.53Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454,746.16v-2.3l2.56-.23v2.53Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1472.17,693.8c-.33-.59-.65-1.19-1-1.81.34-.63.66-1.22,1-1.81,1.77.5,2.1,1.73,1.56,3.62Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1455.06,716.6h2.5V719h-2.5Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1541.43,789.87c-.14-2.94-.14-2.94,1.11-4.67l1.22,2.21Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1490.7,769.52l-2,.87-1-1.32a2.29,2.29,0,0,1-.64-1.92l3.4,1.32C1490.49,768.82,1490.59,769.17,1490.7,769.52Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1456.6,760.66c-1.07-2.17-1.74-3.51-2.52-5.08l2.52-.14Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1495.75,794.13l-1.25-4.91,3.43,2.2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1490.42,803v-3.83l2.42-.16c.07.58.32,1.14.15,1.36C1492.35,801.13,1491.57,801.81,1490.42,803Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1481.5,772l4-1.58v3.42Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1512.94,801.3l1.42-1.42c.71,1.13,2.4,1.47,2.2,3.52C1514.65,803.92,1514.16,802.05,1512.94,801.3Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.72,716.67c-1.29-1.09-2.18-2-1.39-3.57,1.46.25,1.46.25,2.57,1.58C1455.56,715.24,1455.21,715.84,1454.72,716.67Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1450.11,726.74l-2.32,2.89-1.73-1.61C1445.89,727.15,1447.17,726.64,1450.11,726.74Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1474.19,761.88l-3.68-.26,3-3.28C1473.79,759.79,1473.93,760.54,1474.19,761.88Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.92,694.24l-2.92-1.57,3.11-1.07,1.07,1.09Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1496,787l-2.77.25v-2.71C1495,784.31,1495.48,785.39,1496,787Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1483.73,794.2l2.54-2.13c.23,1.29.36,2.06.54,3.07H1484C1483.88,794.83,1483.8,794.52,1483.73,794.2Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1511.25,793.68v-2.75l2.19-.1C1514.41,791.92,1513.59,793,1511.25,793.68Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1526.57,813.63h2.55v2.64C1527.17,816.15,1526.49,815.17,1526.57,813.63Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1462.18,726.57h2.56v2.65C1462.79,729.09,1462.11,728.12,1462.18,726.57Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1504.45,787l3.5,1.73-2.33,2.35-.64-.42c.18-.46.56-1,.5-1.39A9.79,9.79,0,0,0,1504.45,787Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1471.33,758.41l-2-1.58,2.44-1.94c.19,1.38.31,2.23.43,3.09Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1455.52,685.8h3.31l-1.59,3Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1484.86,779.05h-1.59c-.07-.85-.14-1.72-.22-2.59a2.09,2.09,0,0,1,2.72,1.68Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1507.91,811.34l3.11-1.87c.07,1.23.11,2,.19,3.39Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1530.65,807.48l-1.75-2.81h3.54Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1463.38,717l1.52,3-3,.21Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1460.9,682.29l3.26,1.82a7.49,7.49,0,0,1-1.22,1.2C1462.26,685.74,1462.23,685.69,1460.9,682.29Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.16,707.87l-1.35,2.42-1.51-1.56,2.11-1.55Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1533.86,787.09h-2.62c0-.51-.08-.91-.14-1.5h2.64C1533.78,786.11,1533.82,786.65,1533.86,787.09Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1460.68,767.34c-.54-.86-1-1.54-1.4-2.2,1.62-1.44,2.08.19,2.93.76Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1478.56,766.1l-1.44,1.12-1.35-1.35L1478,764Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1523.83,807.28h2.61c0,.51.09.91.14,1.5H1524C1523.91,808.26,1523.87,807.71,1523.83,807.28Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1506.83,780.61l1.75,1.75-2.39,1.36-.48-.56a4.68,4.68,0,0,0,.89-.95A6.14,6.14,0,0,0,1506.83,780.61Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1463.9,738.26l-1.58-.12c0-.54-.08-.94-.14-1.62l2.74-.13Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1540.07,798.05l2.18.17c-.55,1.06-1,1.84-1.72,3.35C1540.31,799.89,1540.19,799,1540.07,798.05Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1543.05,800.64v-3.37c.64.09,1.6-.67,1.33.68a22.72,22.72,0,0,1-.89,2.72Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1498.38,802.47l.42-2.09,2.84,2.09Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1539.73,805.35l1.33,1.33-1.45,1.54c-.39-.55-.78-1.08-1.16-1.6Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1502.07,789.83c0-.45.07-1,.12-1.59l1.62-.14c0,.86.08,1.65.13,2.74Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1443.23,719.86l2.36-1.92c.17.87.26,1.27.39,1.92Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1458.57,717.46h1.62l.26,1.33C1459.24,719.5,1458.49,719.48,1458.57,717.46Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1450.25,748l-1.61-3.12,1.61-.32Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1494.84,773.61v1.81H1493v-1.81Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1482.14,792v1.32l-1.59.33-.33-1.65Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1474,779.13h1.62c.08.46.16.86.25,1.33C1474.66,781.16,1473.91,781.15,1474,779.13Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1458.6,729.13c0,.59-.09,1.13-.13,1.73l-1.55.13c-.06-.55-.11-1-.18-1.71Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1476.69,743.6h-1.62c-.09-.46-.16-.86-.25-1.33C1476,741.56,1476.77,741.58,1476.69,743.6Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1479.9,686.28l1.21,1.93C1480,688.41,1478.87,688.7,1479.9,686.28Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1481.79,776.25h-1.3v-1.56l.43-.32Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1520.6,794.73c.45.27,1,.62,1.91,1.19C1520.31,796.09,1520.31,796.09,1520.6,794.73Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1490.38,786.08v-1.44h2.67Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1502.16,793.79v-1h1.57l.28.39Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1527.9,784.71l-1.2,1.21-.21-1.21Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1460.93,721.84h-1.3v-1.56l.43-.32C1460.35,720.58,1460.64,721.2,1460.93,721.84Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.94,733.67l1.79.14c0,.63-.07,1.12-.11,1.73l-2.14-1.38Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1468.66,745.42H1467l-.27-.31,1.74-.54Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1489.23,772.54h-1.5c0-.14,0-.29-.07-.44l1.52-.33C1489.2,772,1489.21,772.29,1489.23,772.54Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1523.33,792.79l-2.19-.62a6.45,6.45,0,0,1,1.27-.4C1522.54,791.75,1522.72,792.1,1523.33,792.79Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1511,804.28h-1.5l-.06-.44,1.51-.33C1511,803.77,1511,804,1511,804.28Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1521.29,817v-1.5l.43-.07c.12.49.24,1,.35,1.47Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1449.35,706.34h-1.5c0-.14,0-.28-.07-.43l1.47-.35C1449.29,705.82,1449.32,706.08,1449.35,706.34Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.78,724.8v1.51l-.45.06-.33-1.52Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1444.28,693.8V692h.45v1.81Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1462.94,746.57v1.5l-.44.06-.33-1.51Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1474.28,752.75v-.91h.3v.91Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1474.28,786.3v-.91h.3v.91Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1544.11,785.39v-.9h.3v.9Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1491.66,
    cy: 794.01,
    rx: 0.64,
    ry: 0.21
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1544.71,795.07h-.9v-.3h.9Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1528.31,800l-.74-.63.28-.29c.21.25.42.5.64.74Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1526.49,813.6l-.74-.63.29-.29.63.75Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1466.12,693.8v-.9h.3v.9Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1482.14,687.76h.91v.3h-.91Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1456.14,682.92V682h.31v.91Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1471.26,723.73c.3-.3.6-.61.91-.91C1471.86,723.12,1471.56,723.43,1471.26,723.73Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M750.25,1452.31l2.59-4.86h2.48c.74,2.27-.12,4.12-1.47,5.72s-3,2.79-5.2,2.5c-.51-.77-.92-1.41-1.63-2.48l-1.11,2.45h-4.6l-2.48-2.29a3.21,3.21,0,0,1,.26-1.07,2.69,2.69,0,0,1,3.29-1.06c.06.35.14.77.2,1.2s.11.85.18,1.34h2.41c.09-.48.16-.9.25-1.41l-1.61-.56c-.41-1.25-.81-2.47-1.31-4l2.14-1.23,2,1.58-2.49,3a17.92,17.92,0,0,1,3.4,0A13.81,13.81,0,0,1,750.25,1452.31Zm-1.19,1.84v.31H750v-.31Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M800.92,1444.67l1.83-1.07c1.57,1.46,1.57,1.46,1.81,3.1l-5.45,3.44c.5,2.3,3.91,1.54,3.6,4.31a6.33,6.33,0,0,1-5.88-.83c-.39.82-.69,1.44-1,2.13l-1.35-.25,1-1.7-3.84-3,3.67-1.12.38.28,2.87-3.57h2.25C800.82,1445.75,800.88,1445.17,800.92,1444.67Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M775.81,1446.43c.33-1.12.73-2.19,1.15-3.31l3.2-1.07,2.44,1.22-2.25,3.26.87,6.27c-2,.28-3-1.15-4-2.8l-1.63,2.53-2-2.34c.14-.69.43-2,.76-3.65.39,0,1-.09,1.46-.11.4.32.71.63,1.06.89l-.14.13.64.75.3-.29a5.68,5.68,0,0,0-.8-.59C776.52,1447.06,776.21,1446.75,775.81,1446.43Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M787.35,1452.89h-1.89l-1.54-4,5-4.44V1443h6.21c1.5,2.17,1.56,2.65.44,3.76s-2.06.88-4.64-1.27C789.7,1447.93,788.54,1450.37,787.35,1452.89Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M840.68,1420.53l-1.37-3.52-2.49-.44,1.33-2.68,2.1,2H843c1.29-2.45,1.29-2.45,3.78-2.67.1.11.3.21.3.33,0,.6,0,1.21,0,1.94,1.76.06,1.9,1.77,2.73,2.71-1,1.92-2.72,1.3-4.32,1.42-.17-1.08-.31-1.92-.51-3.21-.73,2-1.29,3.55-1.83,5h-1.58Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M877.85,1447.36H880l1.78,4.24,3-2.29h2.93c.74,2.68-.44,4.61-2.24,6.55l-7.59-3.4Zm5.4,4.94v.31h.93v-.31Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M888.1,1392.4l3.46-.71c0,1,.3,2,0,2.44-1.51,1.84-3.3,3.39-5.93,3.28l-1.35-1.36.81-.94c-1.45-1.31-4.26-1-4.69-4.23l3.64.53c.09-.5.27-1.44.5-2.61A5.46,5.46,0,0,1,888.1,1392.4Zm-.22,1.91V1394H887v.31Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M793.76,1433.51h2.87l2-3.21c.69,1.29,1.2,2.23,1.88,3.48a12.16,12.16,0,0,0-2.18,1,8.24,8.24,0,0,0-1.11,1.35c-.39.47-.82.9-1.41,1.54l.52,2.24c-.67.9-1.11,1.5-1.52,2l-2.84-1.25-1.28-2.55Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.58,1402.94c.5-.67,1-1.34,1.68-2.29l2.25,2c-.34.6-.62,1.09-1,1.81l1.67.61c-.1.84-.23,1.89-.4,3.31l1.88,2.68,2-1.15c.14,1.2.23,2,.31,2.71-1.12,1.12-4.5-.08-6.65-2.28l1.19-1.76-2.9.54v-4.34h2.54Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M723.65,1451.07h-1.44l-4,4.61c-1.66-2.59-4.22,2-5.72-.94-1.35,1.75-3.17.52-5.06,1.2.51-1.21.85-2,1.33-3.19,1.27.28,3,1.24,3.85.73,1.55-1,3-.2,4.5-.65.64-1.58,1.39-3.24,3.79-2.61.22-.62.41-1.16.76-2.17Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M816.86,1432.44l-1.64-2.65,0,0-2.13-2.13c.47-2.34.74-3.72,1-5.17h2.55c-.2,1.16-.37,2.21-.6,3.57l.83,1.72c1.64.25,4,.31,3.34,3.19C820,1432.19,818.82,1432.82,816.86,1432.44Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M837.81,1429v4.12c-1.51.85-2.6.26-3.54-1,0-1-.11-2-.18-3.4l-1.33,1c-1.39-1.55-2.68-3.09-2-5.74C833.78,1425.06,835.24,1427.82,837.81,1429Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875,1449.35l-6.45-4.39v-1.83l2.59-1.35,1.31,3.37,3.85-.7c.54,1.13,1.48,2.18,1.26,2.87S876.05,1448.57,875,1449.35Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M904.07,1415.9l.94.93c.64-.85,1.24-1.66,2.09-2.78a2.63,2.63,0,0,1,1.33,0c1.29.6,1.34.83,1.6,3.29l-3.31,1.6-1.81,2.85-2.62-2,1.28-1.58c-.29-.32-.56-.64-.84-1Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M840.63,1450.1c-.69.41-1.43.77-2.07,1.09l-1.58-2v-3.33l3.55,2.39h4.6c.07,1.13.13,2.26.22,3.73l-3.22,1.15c-.58-1.22-1-2.12-1.5-3.06l.13.14.76-.65c-.1-.09-.19-.19-.29-.29A5.22,5.22,0,0,0,840.63,1450.1Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M884.09,1401v3.46l-1.58,1.51-2.41-1.89,1.24-1.59-2.68-1.66c-.22-1.79.23-2.91,2.12-3.54.45.52,1,1.15,1.55,1.77Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M917.28,1446l2.3.83c-.49.84-.92,1.55-1.46,2.48-1.62-1.32-2.2-3.5-4-3.88.3-1.6.56-3,.89-4.71l5.23,2.39C920.39,1445.2,918.76,1445.27,917.28,1446Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M801.9,1437.05V1432l1.35-1.28c2.18,0,2.68,1.61,1.3,4.39l2.7.44v2.22C805.23,1439.09,803.73,1437.14,801.9,1437.05Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M762.1,1450.69c1.17-1.93,3.64-2.61,4.63-4.75.13-.26.75-.36,1.16-.41a8.46,8.46,0,0,1,1.41.12v3.23C765.49,1452.55,764.79,1452.74,762.1,1450.69Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M727.29,1440.87l2.16-2.63,2.6,3.3,3.38-1.71,1.13,1-2.48,2.73-1.31-.77-.95,2Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M913.11,1392.38c-1.64,2.53-1.05,5.93-4.37,7-.51-1.46-1-2.78-1.51-4.36l1.48-.61c.5-1.14,1-2.41,1.76-4Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M743.36,1429.46l1.64-1.63c.73,2.25,4.74,1.63,4,5.15l-1.8,1.9.84,1-1.3,1.3C745.64,1434.57,744.49,1432,743.36,1429.46Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M862.18,1441.56l-3.38-3.38-2.85,2.35c-.26-1.14-.41-1.78-.56-2.42l2.74-2.78,3.47,1.28C861.83,1437.79,863.7,1439,862.18,1441.56Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M807.51,1426.77c-.72,1.94-1.89,2.45-3.57,1.9-.19-.53-.37-1.06-.65-1.85l-2.06,1-1.43-1.35,1.81-1c.2-1.44.31-2.26.43-3.15a3.14,3.14,0,0,1,2.65,2.29C805.09,1425.45,806.4,1426,807.51,1426.77Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.18,1402c1.89-.33,1.27-2.48,2.23-4.13l2.72,2.69-2.21.75a7.4,7.4,0,0,1,.69,1.64,15.64,15.64,0,0,1,0,2.39l-4.71,1.46Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M786.55,1433.59l1.07.78c.2-.55.38-1.08.61-1.71h3.22v2.48l-3,.28c-.68,1-1.3,1.92-2.13,3.12l-3.2-2.87Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M914.56,1425l-2.44.25c-.08.43-.17.85-.3,1.49a13.14,13.14,0,0,0-2.07-.66,11.85,11.85,0,0,0-2,0c-.46-1-.81-1.71-1.16-2.43.4-.41.82-.85,1.42-1.49.81.57,1.62,1.14,2.8,1.95l.45-1.65h3.35Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M784.31,1422.78c-.08.39-.17.81-.28,1.33h-2.39v-3.7l3.37.72c0-.23.13-.65.23-1.15,1.37-1.07,2.42-.31,3.44.84-.3.7-.61,1.43-1.06,2.51Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M878.62,1384.64v-2.51c1.22-1.44,2.52-2.26,4.14-.5l1-.88,2,2-1.11,2-1.59-.79Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M864.48,1428.08l.86,2c-.27,1.05-.55,2.1-.86,3.28h-3.23v-5.28Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M778.3,1430.87l1.12,2.18c-.6.58-.55,1.06.1,1.93.44.59.08,1.78.08,3l-2.48.15c-.49-2.52-.94-4.78-1.42-7.26Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M760.94,1442.69l-1.84-1-3.13,2.89-2.12-2.12v-2.69l2.37,1,1.43-1.91,1.92,1.92,1.37-.73Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M870.51,1448.54l-1.44,1.43-6.09-1.08v-2.25c1.47-.2,2.92-.71,4.07.63l1.63-1.16Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M857.55,1412.14v-3.05l4.24-3.38,1.43,3.23C860.82,1409.62,860.25,1412.43,857.55,1412.14Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M886,1425.51l2.35-1c1.12,1.7,4.22-.72,5.1,2.58l-1.27,1.74h-2.9C889.11,1426.93,887,1427,886,1425.51Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875.47,1425c.41,1.42.69,2.36,1.09,3.76l-3.32,1.42v-2.93l-3.74.74v-2.62a3.35,3.35,0,0,1,1.14-.23,4.61,4.61,0,0,1,1.6.55A2.2,2.2,0,0,0,875.47,1425Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M910.08,1404.64c-.36-2.14,1-3.72,2.09-5.37h2.05c1.42,1.89-.06,3.5-.63,5.37Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M873.07,1405.72v1.58l2.78.54v1.52l-2.53-.57-.39,1.17c-2.53.27-3.37-.11-3.56-1.65C869.16,1406.54,870,1405.93,873.07,1405.72Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M894.63,1446.3a19.73,19.73,0,0,1,2.36.49,16.87,16.87,0,0,1,2.12,1.07c-.43,1.6-.88,3.25-1.38,5.1l-1.89-.39,1.32-2.24h-2.53Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M828.94,1417.28l-3.67,1.14-2.41-1.36c.83-1.39,1.61-2.73,2.41-4.09C827.87,1413.5,827.86,1415.7,828.94,1417.28Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M861.89,1443.9v3.28l-2.55.36c.33.82.6,1.53,1.24,3.14L857.2,1449l1-1.1L857,1446.3C858.48,1445.09,859.1,1443,861.89,1443.9Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M843.28,1424.67v5.17l-1.39,2.32-2.22-2C840,1427.84,840.61,1425.9,843.28,1424.67Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M895.12,1434.81l4.39,2.16-4.08,3.81h-2a6.47,6.47,0,0,1,.3-2.43C894.32,1437.37,895.72,1436.85,895.12,1434.81Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M847.34,1421.42c.79,2.47,1.29,4.06,1.75,5.5a2.7,2.7,0,0,1-3.35,1.92l-1.16-1.21C845.4,1425.78,846.21,1424,847.34,1421.42Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M909.27,1445.87l-1.37,1.37h-3.15v-5l3.18,2.3c.19-.52.39-1.06.86-2.36C909,1443.89,909.15,1444.92,909.27,1445.87Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M757.39,1429.55a2.3,2.3,0,0,1-2.43,2.08,2.26,2.26,0,0,1-2.2-2.31,2.29,2.29,0,0,1,2.66-2.31A2.34,2.34,0,0,1,757.39,1429.55Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.58,1380.16a2.29,2.29,0,0,1-2.08,2.42,2.32,2.32,0,1,1,2.08-2.42Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M743.91,1440h4.78c1.18,1.81-.51,3-.89,4.5l-2,.09C745.23,1443.32,744.67,1441.94,743.91,1440Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M825.66,1445.21a5.79,5.79,0,0,1,3,5.71h-3.32c-.31-1-.67-2-1.08-3.25Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M717.75,1440.79l2.9-1.08,1.83,2.14a21.9,21.9,0,0,0-2.92,2.23,18.77,18.77,0,0,0-1.81,3.27Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M845.45,1376.19H849c.38.93.81,2,1.24,3l-2.62,1.33-2.18-1Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.36,1412.63l3.71-3.76c.29.82.55,1.58.81,2.34l.5-.51v3.23h-3.2l.46-.43Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M827.9,1425.51l-3.08,1.65-2.3-3.44,2.13-1.22Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M899.24,1432.73a9.43,9.43,0,0,0,3.79-4.17l1.93,2.54-2.05.76a4.56,4.56,0,0,1-2.69,4.27C899.91,1435,899.6,1434,899.24,1432.73Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853.76,1429.54c.56.52,1.12.78,1.18,1.13.28,1.45.4,2.94.64,4.9l-3.44-.86C851.87,1431.35,851.87,1431.35,853.76,1429.54Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M894.22,1354.45l-2.8,1.38c-1.47-.85-2.2-2-1.51-3.44a2.16,2.16,0,0,1,2.67-1.25C894.1,1351.62,894.72,1352.72,894.22,1354.45Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M791.9,1424.87c-.4-.79-.72-1.43-1.19-2.39l5.2-2.5c.17,1,.29,1.58.34,2.13.14,1.34.18,2.52-1.85,2.17A7.16,7.16,0,0,0,791.9,1424.87Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M799.47,1402.92l1.69,1.76-2.88,3.32c-.77-.87-1.72-1.48-1.95-2.3C795.87,1404,796.64,1403.44,799.47,1402.92Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M832.06,1405.56c-.57,1.3-1.14,2.63-1.69,3.87l-2.62-1.37c.29.29.07.15.09.08.55-1.69,1.12-3.37,1.61-4.83Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M840,1405.3l2.26,2.87c-.2.44-.55,1.18-1,2.06h-3C837.39,1409.37,838,1407.37,840,1405.3Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M885.56,1408.13a7.34,7.34,0,0,1-.94,6.95l-2.45-3.68A7.05,7.05,0,0,1,885.56,1408.13Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M733.27,1454.09c1.55-2,1.55-2,4.88-3l-1,2.49,1.67,1.67C736.59,1456.36,734.93,1455.33,733.27,1454.09Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.59,1434.41h2.35l2.07,3.24c-2.14,1.72-2.14,1.72-4.58,0C868.48,1436.68,868.54,1435.54,868.59,1434.41Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M898.67,1390.16l-2.19,1.12c-.13-1.45-.23-2.58-.36-4.07.92,0,1.8-.26,2.33,0a36.11,36.11,0,0,1,3.6,2.82C900.82,1391.33,899.78,1391.29,898.67,1390.16Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.37,1418.52l.9-3.39h4.15l-.9,3.39Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.47,1452.92v2.54h-4.34C814,1451.74,814.88,1451.22,818.47,1452.92Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875.71,1383.44h-2.3l-1.69-4.34h4Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M878,1397.73l-3,1.54c-.66-1.6-1.37-3.3-2.2-5.33l2.35-.32Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M878.45,1417.14l-3.47-1.6c0-.53-.05-1.13-.09-1.9l2.35-1.22,2.63,1.29C879.43,1414.77,879,1415.82,878.45,1417.14Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M819.4,1437.63v-2.13l3.36-.2c.29,1.59,2.08,2.7.8,4.78Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M835.9,1415.82h-3.38v-4.31l3.38,1Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M885.26,1362.49l2.45-1.09c.42.78.92,1.73,1.58,2.95l-3.15,2.15-.88-.88Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M837.2,1443.38c.4-1,.68-1.61.95-2.27,1-.6,1.83-.2,3.5,1.68l-3,3C838.16,1444.9,837.68,1444.13,837.2,1443.38Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M776.17,1438.51l-2.28,1.5c-.32-.12-1.33-.2-1.82-.75a8.8,8.8,0,0,1-1-2.7C773.21,1436.11,774.94,1435.76,776.17,1438.51Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M894.6,1344.78c-2.56,2.17-2.56,2.17-4.87.21C891.54,1342,891.94,1342,894.6,1344.78Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M840.6,1374.55v4.17h-3.46a7.71,7.71,0,0,1-.1-2.8C837.59,1374.24,839.2,1375.79,840.6,1374.55Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M816.19,1413.57c-.2-.79-.4-1.58-.59-2.37l-.76.67v-3.17c.45-.07.92-.3,1.26-.17a27.42,27.42,0,0,1,2.63,1.28l-1.63,3.32Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M703.32,1452.9c-1.66.21-2.8-.23-3.32-1.81.42-1.64,1.61-2,3.31-1.86l1.71,1.59Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M844.38,1440H847c.28,1.59.65,3.15-1.05,4.47l-2.45-1.2v-2.34Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M881.66,1421.48l2.14,4.37h-5.19C878.56,1423.84,880.24,1423.39,881.66,1421.48Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M920.57,1425.45l3.32,2.73-2.46,2.48C918.86,1429,918.86,1429,920.57,1425.45Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M881.4,1433.48c.23-3.36.23-3.36,3.37-3.56l1.26,2.64C884.67,1433.77,883,1433.46,881.4,1433.48Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M881.75,1370l1.92-2.23c1.68-.13,2.88.23,3.41,2.35l-2.09.64.48.88a19.13,19.13,0,0,0-1.77-1.09A13.37,13.37,0,0,0,881.75,1370Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M851.28,1360l3.73,1.57-4.6,3.54C849.09,1363.14,850.85,1362,851.28,1360Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M723.18,1451l3,1.57c-.46,1.06-.94,2.17-1.44,3.34C721.73,1454,721.73,1454,723.18,1451Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M890.51,1444.88l-4.3,3.39-1.37-3,1.31-1.3Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M896.94,1399.89l2.47-2.46c1.73,1.08,1.61,2.67,1.28,4.31C898.88,1402.49,897.77,1401.85,896.94,1399.89Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M750.77,1411.49h4.37l-3.46,4.92C750.31,1414.51,751.34,1412.93,750.77,1411.49Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M796.29,1414.59v-2l1.23-1.23,2.73,1.37c-.48,1.08-1,2.2-1.65,3.7Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M918.22,1414.77c.1.88.17,1.59.27,2.51l-2.71,2.57-2.09-1.63C915.2,1417.14,916,1415.33,918.22,1414.77Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M813.15,1438c2.67,1.57,3,3,1.42,5.42-.11.07-.29.21-.31.19-.76-.73-1.51-1.48-1.94-1.92C812.62,1440.35,812.87,1439.25,813.15,1438Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M783.15,1413.4a2.26,2.26,0,0,1,.88-2.33c1.69,1.12,3.5,2,2.86,4.83-2.41,0-2.79-2.42-3.74-2.5a7.43,7.43,0,0,1,1.16.75l.76-.65-.29-.29C784.56,1413.46,784.35,1413.71,783.15,1413.4Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M859.11,1418.58h-3.48v-2.46h4.61C859.82,1417.05,859.44,1417.86,859.11,1418.58Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M862.12,1415.75c1.6,1.14,2.19,2.28,1.54,3.47s-1.95,1.85-3.72.8Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M833.28,1425.15v-2.42l-1.69-.56c-.06-.36-.13-.78-.25-1.45a17.84,17.84,0,0,0,2.31.71,14.53,14.53,0,0,0,2.19,0C835.79,1424.47,835.79,1424.47,833.28,1425.15Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.14,1451.8l2.42-2c.66,1.25,1.16,2.22,1.84,3.5l-1.93,2.25Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M805.73,1454.71c-1.41-2.67-1.41-2.67.87-4.78l1.93,1.82A7.16,7.16,0,0,1,805.73,1454.71Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M781.57,1399.07c2.4,2.31,2.4,2.31,2.45,5l-3.86-1.54C780.65,1401.3,781.08,1400.24,781.57,1399.07Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M879.27,1439.45l3.85,3.61-3.06,1C879.33,1444.59,878.67,1442.37,879.27,1439.45Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M810.07,1446.77v2.06c-1.45,1.44-3.41.05-4.52-3.42Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M880.15,1356.3l3.65,1.78-2.16,2.55C879.71,1359.6,878.92,1358.49,880.15,1356.3Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.24,1455.55h-4.73a1.94,1.94,0,0,1,1.73-2.61C872.84,1452.61,873.62,1453.61,874.24,1455.55Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M886.72,1442.05c-.66-.66-1.08-1.1-1.57-1.6l1.36-1.47,1.87.7,2.15-.86v2.87l-1.75-.85Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M837.75,1436v2.38l-2.72,2.67-1.89-1.64C834.64,1438.33,836.06,1437.29,837.75,1436Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M701.26,1439.4l-3.64-1.77,2.16-2.56C701.7,1436.11,702.5,1437.22,701.26,1439.4Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M832,1438.62l-3.89-1.93,2-2.39C832.06,1434.73,832.68,1435.92,832,1438.62Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M886,1432.58c1.53-.1,3.05-.18,3.82,2l-1.52,1.72C885.87,1436,886,1434.23,886,1432.58Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.59,1432.19l1.88-1.48c1.35,0,1.84.81,1.91,3.46C914.74,1434.85,913.62,1434.27,912.59,1432.19Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M734.49,1422.38h2.06l1.32,2.6-3.38,1.64Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M873.07,1405.56v-3.09c.43-.42.87-.84,1.31-1.28,2.06.88,1.32,2.66,1.52,4.37Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.13,1398.15c.39,1.57.67,2.7,1.06,4.29-1.84-1.18-3.86-1.27-4.71-3.76Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M810.92,1401.83c-1.81.5-3,0-3.83-2.25l1.88-1.32C810.73,1398.74,811.4,1399.83,810.92,1401.83Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M805.19,1386.84l3.65,1.78c-.93,1.1-1.53,1.81-2.17,2.55C804.75,1390.14,804,1389,805.19,1386.84Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M865.22,1385.69l-1.86,3.9-2.49-2C861.58,1385.52,862.77,1385.08,865.22,1385.69Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M898.88,1383.53c.59-.93,1-1.65,1.48-2.33,2.07,1.88,2.07,1.88,2.16,3.89C900.88,1385.84,899.76,1385.23,898.88,1383.53Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M906.94,1378.9a7.33,7.33,0,0,0-1.16-.92,9.42,9.42,0,0,0-1.74-.44l2.62-3.24C908.5,1375.13,908.59,1376.27,906.94,1378.9Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M693.07,1445.51c1.38,1.81,1.38,1.81.94,4.62C691,1448.57,690.92,1448.28,693.07,1445.51Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773.72,1432.85c-2.28-.88-2.77-2-2.24-3.84h2.17c.29.57.66,1.31,1.17,2.34Z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777.82,1422.73l2.07,2.23-1.82,2.33-2.65-2Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.88,1446.83l-3.36,1.61c-.1-.22-.59-1.28-1.25-2.69h4.2C818.61,1446.11,818.75,1446.47,818.88,1446.83Z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830.56,1454.61c-.18-.27-.42-.63-.78-1.19.31-.65.71-1.48,1.11-2.29,1.53-.2,2.08.64,2.24,3.48Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M833.41,1390.37l2.44-1.21c.24.35.62.93,1.16,1.75-.4,1.6-1.68,2-3.6,1.79Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M849.62,1390.61c.49-1.27.92-2.4,1.34-3.48l2.78,1.59C853.19,1390.48,852.2,1391.29,849.62,1390.61Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M908.06,1379.64c.08,1.26.15,2.38.21,3.37l-1.39,1.4C904.7,1381.7,904.75,1381.43,908.06,1379.64Z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M844.07,1399.55l-1.37-2.7c0,.06,0-.11.07-.14.64-.29,1.3-.55,1.8-.75l2.71,2.27Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M898.82,1363l-2.11-2.56c.76-.83,1.34-1.45,2.11-2.3l2.31,1.94Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M897.29,1396.9l-2.31-2.16,1.89-2.26,2.41,1.78Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M863.9,1392.57v-2.19l2.17-1.11,1.6,1.16C867.07,1392.33,866.08,1393.15,863.9,1392.57Z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M905.13,1441.14l-1.48-.62.79-1-1.14-1.64,2.48-2.05c.29.7.65,1.11.57,1.42C906,1438.53,905.59,1439.74,905.13,1441.14Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.59,1373.33s.2.06.3,0a1.81,1.81,0,0,0,.36-.35l2.34,2.34-3,1.18Z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M892.81,1369.71h2.3v3.44C892.59,1372.59,892.6,1372.58,892.81,1369.71Z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M834.15,1365.54l-1.66,1.56-2.28-1.78,2.07-2.72Z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M887.42,1418.68l1.61,1.61-4.58,2C884.78,1420.09,884.78,1420.09,887.42,1418.68Z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M758.47,1422.53v-4c1,.22,2.41.23,2.52.62C761.47,1420.79,760.79,1422,758.47,1422.53Z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M881.56,1351h-4c.23-1,.24-2.4.62-2.52C879.81,1348,881,1348.64,881.56,1351Z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M829.58,1400.63l2.28-2.28c1.14.88,2,1.87,1.17,3.55h-2.19Z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M793.39,1396.57V1399c-1.82.55-3.08.12-3.72-2.06C790.83,1396,792.09,1396.58,793.39,1396.57Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M876.42,1333.51c-1.64.3-2.76-.22-3.48-2,.38-.41.86-1,1.39-1.55.72.92,1.43,1.82,2.32,3C876.7,1332.77,876.55,1333.17,876.42,1333.51Z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M920.11,1426.08H918l-1.28-1.31a2.53,2.53,0,0,1,3.44-1.27Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M788.85,1424.68v3l-2.28.24-1.67-1.67Z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853.12,1413.26c-.59,1.46-1,2.57-1.83,4.57-.76-2-1.18-3.14-1.71-4.57Z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M809.22,1409.9v-1.81c.79-.95,1.58-.77,3.68.85C811.89,1410.11,810.86,1411.19,809.22,1409.9Z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M765.79,1438.1l-3.59,1.36-.21-2.87C763.57,1435.91,764.73,1436.15,765.79,1438.1Z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M811.34,1410.48c.5,1.11.81,1.82,1.16,2.61l-2,1.81-1.62-1.54Z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M930.41,1455.55h-4.16l2.37-3.29Z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M739,1449.07v-2.48h2.55c0,.65.11,1.48.19,2.48Z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M864.85,1413.7l1.52-1.88,2.25,2.19C867.85,1415.44,867,1415.29,864.85,1413.7Z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M824.38,1391l1.87,1.52-2.19,2.25C822.63,1394,822.79,1393.13,824.38,1391Z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M825.63,1430.71h-2.35c-.07-.79-.14-1.61-.23-2.62h2.58Z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M842.88,1388.24l1.88,1.53-2.19,2.25C841.14,1391.25,841.3,1390.36,842.88,1388.24Z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M924.31,1444.63l1.89-1.73c1.53.69,1.8,1.87,1.09,3.87Z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830.66,1442.81h2.46v2.54l-2.46.21Z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853.64,1373.08v-2.34l2.61-.24v2.58Z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M843.46,1440.89l-3.72-1.22a12.22,12.22,0,0,1,2.16-1.35,14.6,14.6,0,0,1,2.48-.28V1440Z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M882.41,1433.48l-2.82,3c-1.46-.82-1.29-1.67.4-3.87.32.3.62.62,1,.89C881.05,1433.55,881.25,1433.48,882.41,1433.48Z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M894.77,1381.28l-3.14-2.69,2.9-1.07C895.34,1377.89,895.66,1379.06,894.77,1381.28Z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M750.09,1437.76c.54-.67.91-1.13,1.53-1.88l2.25,2.19C753.1,1439.5,752.21,1439.35,750.09,1437.76Z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M884,1340.53v3l-2.57.18C881.21,1341.91,882.25,1341.34,884,1340.53Z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M904.69,1404.64v-2.38H908l-2.55,2.78Z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M849.94,1401.9h-2.6v-2.7C849.33,1399.33,850,1400.32,849.94,1401.9Z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M910,1404.69v2.7c-2,.6-2.19-.86-3.12-2.26Z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M852.75,1446.28c-.14-1.86.84-2.44,2.6-2.75.06,1,.11,1.79.17,2.75Z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M921,1449.26l1.58-1.93,2.59,2.59-3.77.26C921.23,1449.87,921.1,1449.57,921,1449.26Z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M819,1449c.67-1.09,1.1-1.79,1.83-3,.44.84.77,1.46,1.35,2.54C821.94,1450.23,820.5,1449,819,1449Z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M913.19,1453.69h-3.37c.58-1.09,1-1.89,1.62-3C912.1,1451.78,912.55,1452.57,913.19,1453.69Z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M741.14,1418h3.69l-1.68,2.73Z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M726,1449.41l3.14-2.32c.28.68.54,1,.46,1.17C729.05,1449.39,728.53,1450.7,726,1449.41Z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830,1421.4l-1.75,1.9-1.36-2.39,1.18-1.18Z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M839,1362.14l4,.23-1.69,2.83Z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M900.61,1370.32c.53,2.36-.86,2.61-2.13,3.42C897.66,1371.45,898.83,1370.89,900.61,1370.32Z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.6,1357.93v-3.38l3,1.63Z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M846.42,1433.73c-.46-2.34.87-2.64,2.18-3.4C849.41,1432.59,848.24,1433.15,846.42,1433.73Z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M886.38,1404.55l2.09,2.62-3.83.55C885.42,1406.31,885.86,1405.5,886.38,1404.55Z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M832,1405.88h3.48l-1.57,2.92Z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.44,1433.34l-1.81,3.16-2-2.65Z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M906.64,1367.21l-2.63,2.08c-.2-1.41-.32-2.28-.55-3.83Z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M855,1389.66c.69,1.13,1.13,1.83,1.77,2.87H853.2Z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M834,1385.93c.87-.68,1.52-1.21,2.63-2.09.2,1.41.32,2.28.55,3.83Z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M904.11,1409.28l-1.81,3.16-2-2.65Z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M839.53,1402.13l1.58-2.06,2,2.45L840,1403C839.84,1402.71,839.69,1402.42,839.53,1402.13Z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M805.51,1416.62v-1.48l3.08-.24-1.44,3Z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M764.72,1440.66l2,1.62-2.49,2c-.2-1.41-.33-2.27-.45-3.14Z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M821.32,1404.1l-2-1.62,2.49-2c.2,1.41.33,2.28.45,3.15Z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853,1409.42h1.43c.07.8.14,1.62.23,2.56l-1.66.33Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M908.11,1409l2.67-.63c.13.66.21,1.07.35,1.74h-2.89Z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.53,1391.68v-1.53h2.67C871.29,1392.74,869.67,1391.6,868.53,1391.68Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.58,1404.79h-2.7v-1.85h2.7Z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M867.19,1438.84l2.54,1.6-2,1C867.41,1441,865.75,1440.5,867.19,1438.84Z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M877.8,1368.36l1.51,2.69-4.13-1.79Z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M822.59,1397.27c.2.84.4,1.68.64,2.66l-1.74.35v-2.89Z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M710,1440h-1.43c-.07-.79-.14-1.62-.22-2.55l1.65-.34Z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M789.7,1386.6l2.25-1.43c1.46,1.65-.2,2.12-.78,3Z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M768.5,1416.59v-1.44l2.55-.22c.12.57.2,1,.34,1.66Z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.43,1373.12l-1.49,1.16-1.58-2.21C867.36,1370.81,867.79,1372.32,868.43,1373.12Z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M846.69,1409.42l-1.42-1.42,2.21-1.58C848.88,1408.12,847.29,1408.59,846.69,1409.42Z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.5,1372.57v1.52h-2.68C888.74,1371.51,890.35,1372.64,891.5,1372.57Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M810.61,1420.66l-2.53-1.38,1.69-1.46,1.52,2Z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M851,1446.89l-1.37,2.56-1.44-1.72,2-1.51Z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M785.92,1431.55h-1.53v-2.68C787,1428.79,785.84,1430.41,785.92,1431.55Z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M688.91,1455.45V1454l2.55-.22c.12.57.2,1,.34,1.65Z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M865.83,1422.46h1.53v2.61h-1.53Z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M735.06,1447.84l1.37-2.56,1.44,1.72-2,1.51Z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M765.6,1431.19c.42-.8.85-1.6,1.37-2.57l1.44,1.72-2,1.52Z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M909,1454.69h-1.53v-2.61H909Z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M812.69,1453.52l-2-1.33,2-2.37Z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.84,1391.92h3.74l-2.06,2.17Z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M814.28,1447l-2.14.39v-3.32C813,1445.31,813.55,1446,814.28,1447Z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M811.51,1439l-1.34-1.33,1.15-1.23C812.91,1437.78,812.91,1437.78,811.51,1439Z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M794.17,1430l1.19,1.2-1.44,1.26-1.54-1.41Z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M894,1429.34c.2.9.31,1.41.46,2.13h-3.31Z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M756.91,1432.34c.38.62.77,1.24,1.2,2l-2.7.17c.22-.87.36-1.43.51-2Z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M841.61,1421.45l-1.27,1.9-1.56-1.44,1.9-1.38Z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M886.25,1353.21l1.19-1.19,1.27,1.44-1.42,1.54Z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M877.76,1418.82c-.12.7-.21,1.22-.38,2.15l-3-2.15Z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M770.86,1455.46l2.63-2.07c.32.84.51,1.32.81,2.07Z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M900.87,1421.93c-.63.57-1,1-1.39,1.28l-1.45-1.27,1.4-1.39Z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M798.8,1422.6l1.19,1.19-1.45,1.27-1.53-1.42Z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M872.87,1387.05h-2.49v-1.89l2.68,1.24C873,1386.61,872.94,1386.83,872.87,1387.05Z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M842.61,1407.31v-3.74l2.18,2.06Z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M803.5,1407.11l-2.13-2.89,2.13-.43Z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M899.08,1403.2l3.57-.33c-.07.77-.13,1.36-.23,2.35Z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M855.56,1426c-.13.92-.21,1.44-.34,2.31-1-.6-1.7-1-3-1.83Z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M812.14,1427.44l2.14,3-2.14.38Z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M906.66,1391.14l-.85,2.07c-.93-.74-1.57-1.27-2.56-2.07Z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M903.77,1451.34l1.64,3.18-1.64.33Z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M824,1409.5h1.65l.26,1.36C824.72,1411.58,824,1411.57,824,1409.5Z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M828.57,1427v1.65l-1.36.26C826.49,1427.7,826.51,1426.94,828.57,1427Z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M899,1424.47v1.34l-1.62.34c-.12-.6-.21-1-.34-1.68Z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M890.82,1454.47l-2-2,1.54-1.53C890.48,1452,890.59,1452.8,890.82,1454.47Z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M737,1436.94v-1.34l1.63-.34c.12.6.2,1,.34,1.68Z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M648,1455.73l-3-.21,2-1.71Z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853.64,1421.7V1423l-1.63.34c-.12-.61-.2-1-.34-1.68Z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M873,1419.84l-2.41,2c-.18-.89-.26-1.3-.4-2Z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M892,1389.2l-2-1.61,2.31-.44c.12.61.2,1,.27,1.44Z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M889.05,1359.45h1.34c.1.47.2,1,.34,1.62l-1.68.34Z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M774.42,1445.65l-2-1.61,2.31-.43c.11.6.19,1,.27,1.43Z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.62,1385.4l-1.76-.14c-.05-.56-.08-1-.13-1.57l1.74-.2C891.53,1384.25,891.57,1384.8,891.62,1385.4Z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M848.08,1381.9v1.34l-1.62.34c-.12-.6-.2-1-.34-1.68Z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.08,1438.79l2.41-2c.18.88.26,1.3.4,2Z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M871.9,1366.85h-1.34c-.1-.47-.2-1-.34-1.62l1.68-.34Z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M826.89,1377.71l2.4-2c.18.89.26,1.3.4,2Z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M890.65,1335.14v-1.34l1.63-.34c.12.6.2,1,.34,1.68Z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.47,1393.45v-1.35l1.62-.33c.13.6.21,1,.34,1.68Z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912,1436.34h1.65l.26,1.36C912.63,1438.42,911.87,1438.4,912,1436.34Z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M845.23,1432.78v1.48H842.5Z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M897.93,1441.89h1.52l-1.19,1.79C898.15,1443.1,898.08,1442.69,897.93,1441.89Z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M762.09,1429.91v-1.52l1.8,1.19Z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M799.19,1445.8c-.08-1-.11-1.35-.16-2.09l2.15.18Z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M868.21,1403.19l1.8-.34c.12.56.23,1.07.55,2.63Z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M917.26,1401.09v2.78h-.46v-2.78Z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M836.32,1401.64l1.22-2C837.72,1401.93,837.72,1401.93,836.32,1401.64Z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M847.59,1386.56l-1.23-2C847.54,1384.38,848.64,1384.09,847.59,1386.56Z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M878.82,1385l-1.86.47c-.07-.69-.13-1.19-.27-2.43Z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M898.29,1380.49l-1.8.34c-.12-.56-.22-1.07-.55-2.63Z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830.52,1455.51l-2.7.13-.06-.62,2.73-.36Z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777.68,1418.55v1.52l-1.8-1.19Z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M764.65,1455.53h-2.46c0-.15,0-.31-.05-.47l2.43-.35Z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.86,1440.66H849v-.47h1.85Z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M799.8,1435.5V1437l-.45.06c-.11-.51-.23-1-.34-1.54Z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M835.91,1451.46l.64-2.24a7.67,7.67,0,0,1,.4,1.29C837,1450.64,836.62,1450.83,835.91,1451.46Z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M923.82,1435.18h-1.53l-.07-.44,1.5-.36C923.76,1434.64,923.79,1434.91,923.82,1435.18Z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M826.64,1438.26v1.53l-.44.07-.36-1.5Z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M786.23,1442h1.53c0,.15,0,.29.07.44l-1.5.36C786.29,1442.5,786.26,1442.24,786.23,1442Z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875.68,1442.58h-1.54l-.06-.46,1.55-.33C875.64,1442.05,875.66,1442.32,875.68,1442.58Z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M907.48,1367H909l.06.45-1.55.34C907.52,1367.54,907.5,1367.27,907.48,1367Z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M876.92,1338.32h1.53c0,.15,0,.29.08.44l-1.51.36C877,1338.85,877,1338.59,876.92,1338.32Z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M887.11,1411.13v-1.54l.44-.07.36,1.51Z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M911.77,1455.54h-1.53c0-.16,0-.31-.07-.46l1.55-.34C911.74,1455,911.75,1455.27,911.77,1455.54Z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M857.51,1399.4H859c0,.15,0,.3.07.46l-1.55.33C857.54,1399.93,857.53,1399.66,857.51,1399.4Z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M801.67,1398.16h-1.54c0-.15,0-.29-.07-.44l1.51-.36C801.6,1397.63,801.63,1397.89,801.67,1398.16Z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830.73,1391.84V1390h.46v1.85Z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M853.78,1380.89h1.54c0,.15,0,.29.07.44l-1.51.36C853.85,1381.42,853.82,1381.16,853.78,1380.89Z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M712,1449.52H713v.31H712Z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M729.63,1455.08h.92v.31h-.92Z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M694.77,1454.77v-.93h.31v.93Z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M913.17,1449.22v-.93h.31v.93Z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M733.64,1451.07v-.93H734v.93Z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M780.84,1455.69v-.92h.3v.92Z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M904.84,1353V1352h.31v.93Z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M906.08,1354.82v.93h-.31v-.93Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 868.91,
    cy: 1365.46,
    rx: 0.65,
    ry: 0.22
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M905.77,1373.33v-.93h.31v.93Z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M784.54,1385.36v-.93h.31v.93Z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 868.91,
    cy: 1422.84,
    rx: 0.65,
    ry: 0.22
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M809.83,1431.63v.93h-.31v-.93Z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M909.78,1431.63v.93h-.31v-.93Z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M832.66,1433.48v-.92H833v.92Z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.16,1433.48v.93h-.31v-.93Z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M895.2,1435.43l-.76-.64.29-.3.65.76Z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M743.51,1436.57h.92v.31h-.92Z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M725,1443.35h-.93v-.3H725Z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M823.41,1445.51v-.92h.3v.92Z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M843.15,1446.44v.92h-.31v-.92Z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.66,1385.26l.76.65-.29.29-.65-.76Z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M815.69,1402.33h.93v.31h-.93Z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M847.78,1402.94v.93h-.31v-.93Z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M900,1404l-.65.76-.29-.29.76-.65Z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.42,1409.11h-.92v-.31h.92Z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M888.5,1412.2v.92h-.31v-.92Z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 911.48,
    cy: 1412.66,
    rx: 0.65,
    ry: 0.22
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M805.61,1416.91c-.21.25-.43.5-.64.76l-.3-.3.76-.64Z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M812,1419.91h.93v.31H812Z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M451.87,815.34A1.51,1.51,0,0,1,450.6,813a14.08,14.08,0,0,1,19.11-4.5,1.51,1.51,0,0,1-1.55,2.59,11.06,11.06,0,0,0-15,3.53A1.52,1.52,0,0,1,451.87,815.34Z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M668,813.54a1.51,1.51,0,0,1-.19-3c4.9-.64,10.61-3.73,12.34-9.19,2-6.22-2-12.59-3.81-15a70.21,70.21,0,0,0-6-6.81c-1.9-2-3.87-4-5.61-6.28A54.37,54.37,0,0,1,658.65,763a1.51,1.51,0,1,1,2.73-1.29,51.48,51.48,0,0,0,5.79,9.68c1.65,2.11,3.56,4.11,5.41,6a73.7,73.7,0,0,1,6.23,7.11c4.39,6,5.94,12.42,4.26,17.73-1.85,5.83-7.81,10.36-14.83,11.27Z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M823.66,294.51a1.52,1.52,0,0,1-1.46-1.11c-2.27-8.34-4.68-16.4-9.25-23.31a32.31,32.31,0,0,0-12.59-11.34,1.51,1.51,0,0,1,1.3-2.72,35.31,35.31,0,0,1,13.8,12.39c4.82,7.29,7.32,15.6,9.65,24.19a1.51,1.51,0,0,1-1.05,1.85A1.41,1.41,0,0,1,823.66,294.51Z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M812.49,372.05a1.53,1.53,0,0,1-.88-.28,1.5,1.5,0,0,1-.34-2.1,44.42,44.42,0,0,0,5.18-40.87,1.49,1.49,0,0,1,.07-1.24,1.47,1.47,0,0,1,1-.77c7.58-1.89,16.12-4.6,22-10.41,5.23-5.12,8.59-14.33,4.53-21.34a8.36,8.36,0,0,0-5.22-4.23c-2.08-.41-4.39.32-6.43,1l-32.48,10.39c-6.09,1.95-12.39,4-17.74,7.53-5.78,3.84-9.56,9.18-10.39,14.65a1.51,1.51,0,1,1-3-.45c.95-6.31,5.21-12.4,11.7-16.71,5.69-3.8,12.2-5.88,18.49-7.89l32.48-10.4c2.28-.73,5.1-1.63,8-1.05a11.27,11.27,0,0,1,7.23,5.67c4.88,8.41,1.16,19-5,25-6,5.88-14.26,8.78-21.81,10.76a47.56,47.56,0,0,1-6.12,42.12A1.49,1.49,0,0,1,812.49,372.05Z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M789.16,305.88a1.51,1.51,0,0,1-1.43-1,44.26,44.26,0,0,0-7.9-14.24,1.52,1.52,0,0,1,.2-2.13,1.5,1.5,0,0,1,2.12.21,46.87,46.87,0,0,1,8.44,15.21,1.51,1.51,0,0,1-1,1.91A1.59,1.59,0,0,1,789.16,305.88Z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M820.7,342.14a1.51,1.51,0,0,1-.69-2.85A18.61,18.61,0,0,0,830,324a1.51,1.51,0,0,1,3,.16A21.64,21.64,0,0,1,821.38,342,1.4,1.4,0,0,1,820.7,342.14Z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M834,338.57a18.17,18.17,0,0,1-7.43-1.51,1.51,1.51,0,0,1,1.24-2.75c8.54,3.86,18.94-1.46,23.69-8.6,4.54-6.83,6.27-16.12,5.29-28.42A113.79,113.79,0,0,0,852,272.67a57.22,57.22,0,0,0-5.76-13,1.51,1.51,0,0,1,2.57-1.59,60.46,60.46,0,0,1,6.07,13.73,116.14,116.14,0,0,1,4.88,25.28c1,13-.85,22.92-5.78,30.33A24.32,24.32,0,0,1,834,338.57Z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M856.61,337.43a23.59,23.59,0,0,1-10.91-2.62,1.51,1.51,0,0,1,1.39-2.68c9.16,4.75,24.33,2,32.87-10.63,8-11.9,7.52-26.94,5.7-37.47a56.47,56.47,0,0,0-3.92-13.45,1.51,1.51,0,0,1,2.75-1.23,58.63,58.63,0,0,1,4.14,14.16c1.92,11.08,2.41,26.95-6.17,39.67C877,331.22,866.88,337.43,856.61,337.43Z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M883.08,339.23A22.19,22.19,0,0,1,868.32,334a1.51,1.51,0,1,1,2-2.26c5.28,4.64,13.37,5.8,21.11,3a1.51,1.51,0,1,1,1,2.84A27.73,27.73,0,0,1,883.08,339.23Z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.42,445.82c-4.32-.08-8.42-.12-12.43-.16-18.35-.18-34.19-.33-59-4.65l.78-4.45c24.42,4.25,40.09,4.4,58.24,4.58,4,0,8.15.07,12.49.16Z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.71,383.23a1.5,1.5,0,0,1-1.41-1,60.32,60.32,0,0,1,1.75-45c-7,1.82-14.81,3.79-22.37,1.79a19.37,19.37,0,0,1-12.22-10.41,12.75,12.75,0,0,1,0-11.15c3.51-7,12.11-8.73,20.07-9.54l27.64-2.82c2.3-.24,4.94-.46,7.52-.5a1.51,1.51,0,0,1,0,3h-.12a68.71,68.71,0,0,0-7.08.48l-27.65,2.82c-7.14.73-14.82,2.23-17.68,7.9a9.77,9.77,0,0,0,.09,8.55,16.21,16.21,0,0,0,10.24,8.73c7,1.85,14.27-.07,21.32-1.92l2.7-.7A1.52,1.52,0,0,1,195,334a1.55,1.55,0,0,1,.15,1.64,57.16,57.16,0,0,0-3.05,45.58,1.51,1.51,0,0,1-.9,1.93A1.37,1.37,0,0,1,190.71,383.23Z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M173,311.36a1.5,1.5,0,0,1-1.46-1.12,76.38,76.38,0,0,0-10.21-22.68,49.6,49.6,0,0,0-5.31-6.78,1.51,1.51,0,0,1,2.18-2.08,52.06,52.06,0,0,1,5.64,7.19,79.45,79.45,0,0,1,10.62,23.58,1.51,1.51,0,0,1-1.07,1.84A1.31,1.31,0,0,1,173,311.36Z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.47,358.69A18.89,18.89,0,0,1,144,355a1.51,1.51,0,0,1,1.84-2.4c4.51,3.47,11.62,4,17.29,1.38s10.6-8.37,13.57-15.91a1.51,1.51,0,1,1,2.81,1.1c-3.26,8.27-8.62,14.5-15.1,17.54A21.22,21.22,0,0,1,155.47,358.69Z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.12,362.6a1.51,1.51,0,0,1,0-3c8.41-.08,17.66-1,22.47-7.19,5-6.47,3.15-16.17,1.3-22.91a169,169,0,0,0-12.08-31.41c-1.84-3.64-4.09-7.75-7.53-10.41a14.44,14.44,0,0,0-3.63-2,1.52,1.52,0,0,1-.85-2,1.5,1.5,0,0,1,1.95-.85,17.58,17.58,0,0,1,4.38,2.46c3.93,3,6.38,7.5,8.37,11.44a171.54,171.54,0,0,1,12.3,32c2,7.36,4,18-1.83,25.56-5.59,7.21-15.69,8.27-24.82,8.36Z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M109,369a18.24,18.24,0,0,1-7.94-1.77c-6.78-3.32-12-10.56-14.82-20.38a1.51,1.51,0,0,1,2.91-.82c1.47,5.2,5.14,14.52,13.24,18.49a15.74,15.74,0,0,0,12.4.38,10.89,10.89,0,0,0,6.4-6.18c1.06-2.87.84-6.13.43-9.22a82.38,82.38,0,0,0-16.88-40.18c-1.68-2.14-4-4.77-6.73-6.1a1.51,1.51,0,0,1,1.31-2.72c3.32,1.6,5.91,4.56,7.79,7a85.4,85.4,0,0,1,17.5,41.65c.46,3.48.7,7.18-.59,10.65a13.82,13.82,0,0,1-8.11,7.94A18.64,18.64,0,0,1,109,369Z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.29,350.62h-.09a19.25,19.25,0,0,1-13.08-6.25,1.5,1.5,0,1,1,2.23-2,16.29,16.29,0,0,0,11,5.26,1.51,1.51,0,0,1-.09,3Z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.11,1030.55a85,85,0,0,1-18.72-1.93c-14.42-3.26-27.1-10.85-39.36-18.18l2.33-3.89c11.95,7.16,24.31,14.56,38,17.66,14.59,3.3,30.12,1.49,44.79-.63l.65,4.47A194,194,0,0,1,597.11,1030.55Z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.59,498.26l-.74-4.47a131.72,131.72,0,0,0,49.23-18.9l2.44,3.81A136.49,136.49,0,0,1,172.59,498.26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 221.51,
    y: 1455.35,
    width: 225.71,
    height: 4.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 558.04,
    y: 1455.59,
    width: 1295.35,
    height: 4.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.22,
    y: 1455.41,
    width: 110.82,
    height: 4.52
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.24,1498.12q-1.93,8.4-4.21,17l-.19.69-97.23.15a116.57,116.57,0,0,1-9.19-18c-5.67-13.54-10.17-29.51-13.73-45.67-1-4.39-1.89-8.81-2.72-13.19-2.85-15-5-29.57-6.46-42-.75-6.17-1.35-11.83-1.83-16.75-1.17-12-1.6-19.61-1.6-19.61l12.16-.35,141-4S577.17,1421,559.24,1498.12Z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432,1439.11c.83,4.38,1.74,8.8,2.72,13.19-17.62,4.71-38-.84-49.63-14.89-11.89-14.33-13.05-37-1.49-51.63,5.13-6.48,12.76-11.35,21-11.64,6.81-.24,13.19,2.54,19.07,6.18.48,4.92,1.08,10.58,1.83,16.75a21.57,21.57,0,0,0-26.37-2.19c-7.6,5.26-10.94,15.58-8.7,24.53s9.49,16.25,18.15,19.43A37.16,37.16,0,0,0,432,1439.11Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 457.61,
    y: 1513.58,
    width: 97.23,
    height: 4.52,
    transform: "translate(-2.48 0.83) rotate(-0.09)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1492.73,1478.3a287.65,287.65,0,0,1-15.36-95.82v-.27l43.2-.78,33.41-.6,45.31-.8v1.1a287.7,287.7,0,0,1-21.22,118.24l-76.87.85Q1496.52,1489.45,1492.73,1478.3Z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1548.41,1247.17c1.35,44.23,5.42,97.63,5.57,133.36v.3l-33.41.6v-.15q-1.12-12.35-2.28-24.68c-.58-6.27-1.3-12.92-5.22-17.84-4.47-6-14.7-10.79-24-16.66-4.56-2.87-9.08-6.24-11.57-11s-2.4-11.32,1.58-15a11.66,11.66,0,0,1,10-2.49,19.88,19.88,0,0,1,9.32,5c2.51,2.28,4.67,5,7.45,6.92,2.26,1.57,6.25,3.44,8.16.35a7.52,7.52,0,0,0,.87-3.71c0-.53,0-1,0-1.57.1-5.11-1-10.51-1.38-15.64-.45-5.77-.85-11.54-1.12-17.31a290,290,0,0,1,.15-34.76c.46-6.59,1.61-13.88,6.83-17.91,7.13-5.49,18.26-1.33,23.23,6.15S1548.14,1238.17,1548.41,1247.17Z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1577.33,1498.26h-1.49c-.46-1.06-.93-2.16-1.48-3.45l1.47-.29,1.5,1.89Z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1502.37,1484.38c.32,1.9,1.74.23,2.52,1.43.2-1.48.32-2.32.55-4,1,3.81,4.06,3.93,6.19,5.32l1,1.68-1.09,2.47.5.47,1-.92c2.18,1.09,2.18,1.1,3.42,3.69l-2.83-.66-1.61,2.67,3.52-1.5-1,2.92a3.87,3.87,0,0,0,1,.27c2,.06,3.24-1.2,4.54-2.44a29.62,29.62,0,0,1,2.95-2.07l-1.24,3.7,1,2.13c-3,2.11-6.1-1.39-9.16.32l-.73-.66-.64.64-4.37-2.24c-.61-1.58,1-2.82,1.57-4.52-.78-.81-1.22-1.79.27-2.71l-1.5-1.39c-.38,2.4-.74,4.74-1.16,7.4h-5.7v-1.85l.92-.7-.92-1.15c0-.15.06-.36,0-.44-.41-.44-.85-.85-1.5-1.47l-1.64,2.4-1.24-4h2.23C1499.47,1487,1500.3,1485.23,1502.37,1484.38Zm2.78,5.56H1507c-.09-.79-.14-1.3-.2-1.78-1.6,0-1.59,0-2.61.85h-3.7c2.22,1.48,3.72,2.29,4.71,3.6l-.18.19.65.75.29-.29a2.55,2.55,0,0,0-.84-.55Z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1514,1486l3.07-1.57c.65,1.39,1.37,2.89,2.17,4.59l1.4-.93,3.85,1.25v2.52l-1.26-.91-1.8,1.34c-.43-.9-.83-1.75-1.17-2.48l-2.27,1.12C1516.34,1489.59,1516.66,1487,1514,1486Z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1508.62,1475.67l-3.42,4.66-1.91-3.15a16.66,16.66,0,0,0,.91-2.34,17.29,17.29,0,0,0,.21-2.48h1.33c.17.52.35,1.05.61,1.82l1.3-.94C1507.87,1473.79,1508.14,1474.45,1508.62,1475.67Z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1493.32,1475.23l1.39-.14c.16,1.54.32,3.1.56,5.44.87-2.19.48-4.46,3.19-4.5v4.36l-3.7,1.2C1492.92,1479.76,1492.83,1477.57,1493.32,1475.23Z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1531,1499.24c-.19,1.76-1.65.23-2.23,1.16-.4-.93-.66-1.54-.88-2l-1.48.83v-2.63a14.68,14.68,0,0,0,2.57-.18,14.12,14.12,0,0,0,2.29-1,2.78,2.78,0,0,1,1.37,3.76c-.46,0-1,0-1.64,0l.14-.13-.65-.76c-.09.1-.19.19-.29.29A5.22,5.22,0,0,0,1531,1499.24Z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1512.2,1478.64l1.52-1.05,1.67,3-5.41,2.23c-.09-1.69-.17-3.13-.27-5.12Z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1527.23,1490.18l4.63-2.6c-.15,1.25-.23,2-.38,3.19l.61,1.58C1529.58,1493.44,1528.56,1491.74,1527.23,1490.18Z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1540.33,1494.93a2.53,2.53,0,0,1,3.61,1V1499h-2.37C1541.19,1497.78,1540.75,1496.34,1540.33,1494.93Z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1520.67,1477c.45.73.88,1.45,1.58,2.6l-2.86.15c-.15.41-.32.93-.56,1.63h-2.51c0-.51-.11-1.14.1-1.3C1517.76,1479.06,1519.17,1478.1,1520.67,1477Z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1496,1469.74l-1.45,4.72c-2-1.07-2.39-2.69-2.28-4.72Z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1490.58,1461.36c-.13-.7-.21-1-.23-1.27,0-.13.1-.26.19-.48,1.1-.19,2.25-.36,3.39-.57a4.84,4.84,0,0,1,3.08.12c-.44.38-.81.93-1.32,1.13A23.25,23.25,0,0,1,1490.58,1461.36Z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1546,1499.19c-.29-2.14.83-1.7,1.65-1.89a11.59,11.59,0,0,0,2.34-1.08,11.15,11.15,0,0,0,1,2c.56.73.38,1-.44,1Z"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1505.15,1499.19c-1.14.44-2.15,1.64-3.54.62a2.39,2.39,0,0,1-.91-3.08c.07-.17.49-.21.75-.32.38.31.76.88,1.14.88A2.37,2.37,0,0,1,1505.15,1499.19Z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1488.86,1465.63c.91-1.2,1.48-2,2-2.66,2.15.58,2.51,1.84,2,3.83a6.67,6.67,0,0,0-1.43-.9A17.77,17.77,0,0,0,1488.86,1465.63Z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1523.47,1487.47l-1.23-3.89.93-1C1525.19,1482.53,1525.4,1483.63,1523.47,1487.47Z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1502.11,1480.26l-1.09,1.41c-1.85-2.45-1.87-2.65-.2-5.06C1501.31,1478,1501.73,1479.19,1502.11,1480.26Z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1528.09,1491.79c.24,1.14.48,2.25.75,3.49h-3.11l1.08-3.49Z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1492.21,1466.8l-1.5,6.32c-.19-1.62-.21-2.41-.39-3.16a13.76,13.76,0,0,0-.73-1.9,6.58,6.58,0,0,1,1.25-1.22C1491.18,1466.64,1491.73,1466.8,1492.21,1466.8Z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1536.37,1494.63c-1-1.12-1.8-2.09-3-3.43l2.75-.4,1.25,2.46Z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1556.2,1491.87h2.47v2.54l-2.47.2Z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1530.33,1481.18l3,1.83-2.53,1.35C1529.13,1484.15,1530.39,1482.71,1530.33,1481.18Z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1498.13,1463.79l2,2.64-3.84.51C1497.13,1465.52,1497.59,1464.73,1498.13,1463.79Z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1486.83,1454.34l3,1.83-2.53,1.35C1485.63,1457.31,1486.9,1455.87,1486.83,1454.34Z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1532.91,1475.6l-1.42,1.42-1.57-2.22C1531.61,1473.41,1532.09,1475,1532.91,1475.6Z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1497.26,1487.41l-3.12-4.21,3.64,1.58C1497.69,1485.25,1497.59,1485.76,1497.26,1487.41Z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1542.09,1490.09v1.54h-2.62v-1.54Z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1544.18,1485.39h1.53v2.68C1543.12,1488.15,1544.26,1486.53,1544.18,1485.39Z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1565.44,1486.71l-1.38,2.47-1.54-1.6,2.16-1.57Z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1527.26,1499.85l-3.57.34c.08-.77.14-1.36.23-2.35Z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1559.29,1497.2l.76,1.78-2.85.26A4.68,4.68,0,0,1,1559.29,1497.2Z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1499.93,1467.28l2.91,2.14h-3.32C1499.66,1468.71,1499.76,1468.2,1499.93,1467.28Z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1552.68,1493.56h-2.82a4.7,4.7,0,0,1,2-1.91C1552.11,1492.16,1552.3,1492.64,1552.68,1493.56Z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1516.91,1494.33l.85-2.07,2.56,2.07Z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1507.14,1464.57l-1.61,2-.44-2.31,1.44-.28Z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1495.65,1454.68l-2-2.4,2-.4Z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1568.22,1492.34l-1.61,2c-.22-1.15-.32-1.67-.44-2.31l1.44-.27Z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1498.22,1481.47l2.49,1.39C1499.06,1484.3,1498.58,1482.64,1498.22,1481.47Z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1513.24,1486.15l-2-2.41,2-.4Z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1524.3,1470.32l-2.06,2.06-1.36-1.57Z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1549.49,1490v1.65l-1.36.26C1547.41,1490.63,1547.43,1489.87,1549.49,1490Z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1554,1498.26h-1.35c-.09-.46-.2-1-.33-1.62l1.68-.34Z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1520.33,1487.3l-2-1.62,2.31-.43c.11.61.19,1,.27,1.43Z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1499.6,1493.64c.08-1.39,1.15-.79,1.85-.93v1.85h-.93Z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1568.26,1498.42h2.45c0,.17,0,.33,0,.49l-2.49.33Z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1514.4,1486.23c-.43,1.79-1.86.58-2.77.93C1512.06,1485.38,1513.49,1486.59,1514.4,1486.23Z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1537.86,1486.79l1.24-1C1539.2,1487.07,1539.2,1487.07,1537.86,1486.79Z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1527.8,1485.46l-2.29-.65a8.49,8.49,0,0,1,1.3-.4C1526.94,1484.39,1527.13,1484.74,1527.8,1485.46Z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1523.89,1496.41v-1.85h.46v1.85Z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1536.64,1499.91l-1.77.15c0-.2,0-.4-.08-.6l1.8-.35Z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1565.13,1499h-1.53l-.06-.45,1.54-.34Z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1536.78,1496.57h1.54l.06.46-1.54.33Z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1570.71,1496.26h-1.54l-.07-.44,1.51-.36C1570.64,1495.72,1570.68,1496,1570.71,1496.26Z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1499.45,1472.19h-1.53c0-.14-.05-.29-.08-.44l1.51-.36C1499.38,1471.66,1499.42,1471.93,1499.45,1472.19Z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1488.03,
    cy: 1461.25,
    rx: 0.33,
    ry: 1.31
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1502.35,1483.66l1.77-.15c0,.2.05.4.08.6l-1.8.35C1502.38,1484.2,1502.37,1483.93,1502.35,1483.66Z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1536.52,1499.11c.21-.26.43-.51.64-.76l.29.29-.75.65Z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1505.23,1499.09l.76.65-.29.29-.65-.76Z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1538.47,1480.06h.92v.31h-.92Z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1556.67,1486.23v.93h-.31v-.93Z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1525.82,1480.68v-.92h.31v.92Z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1491.58,1475.13v-.93h.31v.93Z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1499.6,1494.56l-.77-.62.77-.3Z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1500.52,1494.56c-.2.26-.41.51-.62.77l-.3-.77Z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1536.7,1494.47l.75.64-.29.29-.64-.75Z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1562.22,1494.56v.93h-.31v-.93Z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1491,1447.36v.93h-.31v-.93Z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1504.22,1489l.93.93Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CXtvMH.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M485.27,1511.79c0-.56,0-1.15,0-1.8l-1.45-.66c0-.41,0-.76,0-1.15l.1.1.59-.5-.23-.23a4.07,4.07,0,0,0-.46.63c-.76-.07-1.38,1.88-2.33,0-1.05.57-1.64,2.28-3.3,1.2v-1.59l-1.57-.52v-2l1.36-.92-.93-1.93-3.38.93c.7,1,2.22,1.65,1.28,3.28h-2.95l-1.2,1.2,1.24,1.05.95-1.75c1.48,1.3,2.28,2.66,4.11,2.7.42,0,.83,1.21,1.17,1.73l-2.13,3.19c-1.6-.36-1.1-1.07-.35-1.78l-.93-1.87c-.25.21-.49.42-.83.69l-1.78-2.41-2,2.7-4.05-1.81-3.89.71c-.83-1.3.79-1.61,1.22-2.45v-3l1.94-1.33c-.51-1.15-1.14-2.49.39-3.82l-1.42-.29v-4.33l1.68.54,2.3-.66c.88-1,1.8-2.1,3-3.49l-.73-1.7,3.48-1.22c.12.67.23,1.3.37,2l1.15.4c.75,2-.47,3.76-.76,5.61a12,12,0,0,0-1.26,0l.11-.1-.51-.6-.23.23a4.13,4.13,0,0,0,.63.47c.19,1.36,1.47.2,2.22,1.29.22.66.62,1.81,1,3l1.69-1.59,1.6,1.6a6,6,0,0,1,.08-2.45c.31-.63.77-1.13.61-1.92l.1.11.59-.51-.22-.23a4.13,4.13,0,0,0-.47.63c-1.31.36-2.28-.71-3.76-.87.35-1.64.68-3.15,1-4.77h1.81c.09.27.23.68.44,1.33h2c-.23.74-.46,1.48-.79,2.52l1.57.64v2.91c.71-.35,1.09-.55,1.47-.72s.62-.25,1.31-.52c-.15.85-.26,1.42-.41,2.21l2.77.42L487.2,1503c-1.12.58-1.93.06-3-1.94h-1.78c0,.4-.19.9,0,1,1.31,1.08,2.68,2.09,3.93,3l1.44-.6c1,1.72-.3,2.46-1.49,3.84l3.29-.87.73.73c-.95,1.61-2.47,2.93-2.24,5.12.05.47-.72,1-1.2,1.65l-1.29-.91-.92.84c-.38-1-.73-1.84-1.21-3.08.91,0,1.35,0,1.82,0l-.1.1c.16.2.33.4.5.59l.23-.22A4.13,4.13,0,0,0,485.27,1511.79Zm-13.91-13.61-2.89,1,2.89,1.28c0-1,0-1.67.05-2.43l.14.14.6-.5-.23-.23A4.39,4.39,0,0,0,471.36,1498.18Zm-5,9,2.44,1.17c.63-1.27,1.19-2.41,1.75-3.56l-.51-.5,1.33-1.4-.95-1.86-3,.88C467.08,1503.58,466.75,1505.23,466.38,1507.14Zm13.67-2.6,1.31,2.33,1.33-2.14Zm-10.73-8.46v.37h1.44v-.37Zm11.1,7.06h.24v-.72h-.24Zm-13.76-2.89h.24v-.73h-.24Zm7-6V1494h-.72v.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M452.67,1496.63l1.92.49c.29-.85.64-1.91,1-3.09l-1.37-.44v-2.41c1.58-.49,1.76-2.7,3.59-3.33l1,.78.74-.65,1,1c-.65.43-1.6.72-1.9,1.32a2.33,2.33,0,0,1-1.76,1.49c.14.64.32,1.27.41,1.91a18.66,18.66,0,0,1,0,1.9l2.92-2.53h1.65a3.2,3.2,0,0,1-1.31,3.53l-.24-.6-.48.6-.6.24.6.48.24.6.48-.6a6.4,6.4,0,0,1,1.27.24c0,1.14,1.08,1.2,1.91,1.61-.39.61-.62,1-1,1.55.45.32,1,.71,2,1.41l-2.65.37v1.85h-3c-.28-1.81,1.38-1.63,2.12-2.34,0-.36,0-.71,0-1.1l.1.11.59-.51-.23-.23a4.07,4.07,0,0,0-.46.63c-.45-.23-.94-.48-1.51-.79l-1.07.82-3.06-1c-.06-.44-.16-1.1-.34-2.34-.38.91-.56,1.33-.8,1.92l-3.36-.47c-.32-.54-.93-1.54-1.74-2.87l1.78-.32.72.73.25,1.37.48,0Zm7.24,2.65V1499h-.73v.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M457.77,1482.84c-.52-.52-1-1.07-1.83-2-.27,1.27-.43,2-.58,2.69-1.19.19-1.5-.19-2-2.27,2.25-1.78,4.54-3.45,7.82-2.61v-2.11l3.15-.26a5.49,5.49,0,0,0-.58.92c-.12.44-.17.89-.25,1.33H462l.92,1.61-3.38,2.58,3.31,1.25c-.33,1.26-.7,2.62-1.15,4.33l-2.51-2.38c0-.27-.1-.84-.17-1.46-.22.07-.46.07-.53.18-.56.85-1.08,1.73-1.68,2.7l-1-.95c.23-1.13.46-2.19.74-3.52.3,0,.74,0,1.22,0l-.11.1c.17.2.34.39.5.59a2.5,2.5,0,0,0,.23-.23A4,4,0,0,0,457.77,1482.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M489.58,1507.48c0-.9-.29-1.91.7-2.55l-2.24-1.29c.72-.88,1.35-1.65,2.24-2.72,0-.33.06-1.13.11-2l1.8-.17c.38-.79.77-1.59,1.5-3.12l-1.84,1c-1.21-.22-1.31-.82-1.05-2,.17-.77-.43-1.7-.64-2.39.76-1.25,1.59-1.73,2.79-1.31.81,1.41-.15,2.61-.75,4.32l2.77-.81,1.09,1-.74.9.91,2-1.58.74v1.12a1.91,1.91,0,0,0-2.17,1.34c-.43.91-.87,1.8-1.4,2.89l1.39,1.12c.13,1.75-.45,2.69-2.16,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.33,1479.25l1.8-.94c.18.53.37,1.13.58,1.76l-1.77,1.11,3.34,1.14,1.51,3.09c-.13.67-.3,1.49-.47,2.35l2.26.36-4.86,4.86h-2.07c-.31-.61-.61-1.2-1-1.89.34-.87,2,.53,2.09-1H451c.25-1.47.51-3,.84-4.86l-1.87-1.43-3-1C446.75,1481.43,448,1480.51,448.33,1479.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M457.74,1474.19,456,1473l-2.22.71-.84-1.57-3.37-.16c.39-1.25.72-2.28.93-2.94l3.64-2.76.72-.73,4.34,1.45-.72,2.17h-1.88l-.46-1.34-1.89.88c.28.58.55,1.16.86,1.79l1.63-.82C456.88,1471.29,458,1472.53,457.74,1474.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M487.45,1495.21l1.73,1.27-1.18,1.41c-.14,0-.29.12-.3.1-1.11-1.57-2.88-2.15-4.85-3l2.21-1.61s-.11-.31-.22-.31c-.83,0-1.66,0-2.49,0v-1.91c1.64-1.1,3,1.34,4.58.42l2.52-1.85.18,2.32-2.22,1.41c0,.57,0,1.18,0,1.81l-.1-.11-.59.51.22.23A4.13,4.13,0,0,0,487.45,1495.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.33,1479.25h-2.57c-.22-.46-.45-1-.67-1.43l-.83.7c0-1.74,0-1.74,2.76-2.64-.5-.11-.83-.19-1.16-.24s-.67-.08-1.29-.15l.61-1.61c-.19-.63-.4-1.35-.66-2.24l3.36-1.35c.4.57.75,1,1.23,1.71l-1.35,1.83c.55.65,1,1.42-.13,2.12C448.83,1476.86,448.14,1478.15,448.33,1479.25Zm-1.69-6.51h-.24v.72h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444,1462.48l1.85.71,1.2-.86,1.27,2.38c-2,3.61-2.4,4.17-5,6.16l.95,1.59-1.43.31-.56-1.39-1.81-.2v-1.88l3.69-1.36,2.2-3.25-2.56-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.71,1476.65c.58-1.4,1-2.3,1.2-2.86l2.86.22,2.6,2.1-.41.53.76,1.31-1.83,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465,1488.2l3.39.7c1.3.77.8,1.95.92,3.22l-3,.3c.31.41.53.68.93,1.19l-1.75,2.26-1.38-2,.57-1.2c-.1-.22-.27-.66-.48-1.09s-.44-.77-.65-1.15Zm1.39,2.09v.37h1.45v-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M460.63,1470.57c1.06-.48,1.93.62,3.09.27.82-.24,1.87.36,2.83.43,1.15.09,2.31,0,3.55,0-.16,1.83-1.18,1.91-2.37,2.31-.79.26-1.83-.45-2.38.57-.51-.48-1-1-1.53-1.45l-2.41.82c-1.1-.5-1.67-1.15-1.5-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M494.63,1510.55c.44-.34.79-.6,1.35-1,.38.86.74,1.66,1.2,2.72l4.95,1.86c-.37.37-.46.53-.54.53-1.77-.14-3.72-.82-5.28-.32-1.81.58-3.43.09-5.64.55l1.29-2.37,1.2.88,2.08-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M510.44,1509l.53,1.38-.8,1.87-1.44-1.09-.73.73c-.88-1.14-1.75-2.24-2.77-3.54l-1.83-.28v-3.34h2.77l-.46,1.89c.92.83,2,1.84,3.38,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M475.83,1486.49l-1,.49c-1.47-.13-1.06-1.51-1.12-2.31h-2.09v1.62h-3.37l3-4.34,1.43.83,1-.68c1.59.39,1.38,2.5,3,2.64a9.91,9.91,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M442.7,1460.53l-2.45-1.2c.23-.48.46-1,.73-1.51l-.68-.72a12.58,12.58,0,0,1-2.38.39c-.36,0-.71-.58-1.31-1.11l1.3-.53-.28-.38h6.28c0,.58,0,1.23.09,1.94l-1.9.2C442.29,1458.53,442.48,1459.47,442.7,1460.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M520.71,1510.38v2.9c-.32.37-.63.75-1.16,1.38-1.9.39-3.5-.45-5.3-2.52l3.45-.48.31-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M485,1484.87l4.41,2.07,1.31-.53c.71,1.39.23,2.23-.87,3-.12-.46-.23-.85-.37-1.38h-4.32l-1.66-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M517.61,1499.64l.93,1c0,1.25-.87,1.64-2.88,1.43.23-.27.45-.52.86-1l-1.95-.19-1.52,1.52L511.9,1501l1-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M480.8,1514.6c.34-.43.54-.67.92-1.13-1.72-.18-3.45-.42-2.86-3.07.67.13,1.39.25,2.1.41s1.31.33,2,.52v3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497.12,1506.44l1.58-1.81h1.6l1.93,3.22-1.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M476.56,1485.77h1.3c.08,1.1.15,2.22.24,3.45.3.06.66.23.93.14s.53-.45,1-.88c.06.81.12,1.46.2,2.53l-2.37-1-.61.45-1.68-.75,1.05-1.79c-.28-.51-.53-1-.79-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M494.48,1489.13l-1.68-1.64c1.49-2.21,3.52-1.93,5.38-2.73V1487a7.21,7.21,0,0,0-1.91.46A10.16,10.16,0,0,0,494.48,1489.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.94,1490.52l-2.83-1.34c-.21-.69-.5-1.59-.9-2.86l2.07.88,2.39-1C450.39,1487.82,450.2,1489,449.94,1490.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M438.36,1435.58a5,5,0,0,1,1.13,4.47H437C436.28,1439.41,436.62,1438,438.36,1435.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M454.12,1466.23h-1.84l-1.1-3.23,1.54-1.41c.32.45.51.69.67.94s.44.78.71,1.13.59.48.71.78a2.88,2.88,0,0,1,0,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M529.18,1512.57l-1.42-1c-.38.68-.68,1.2-1,1.71-1.15,0-1.47-.5-1.77-2.87l2.71.31,2.77-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M462.13,1459.3l-1.2,1.2-2.19-1-.82-1.64c.31-.41.61-.78,1-1.33C460,1457.57,461.9,1457.39,462.13,1459.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M445.65,1446.23l-2,1-1.23-1.15c.26-.43.49-.81.78-1.31l-1.47-.67c.32-.58.64-1.13,1-1.7.26.1.49.12.58.24C444,1443.77,444.74,1444.88,445.65,1446.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M453.94,1504.78l-1.46-.51,1.19-2,2.85,4c-.47.57-.9,1.07-1.53,1.81C454,1506.87,453.52,1506.12,453.94,1504.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M460,1505.5c-.38,1.23-.72,2.28-1.06,3.37h-1.78v-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M518,1505.87c-.69,2.6-2.36,2.93-4.16,3.1-.38-2-.38-2,1-2.23A32,32,0,0,0,518,1505.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M467.89,1485.36l-4.47-1.15,3.26-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.74,1473.33v2.87h-2.86A3.5,3.5,0,0,1,459.74,1473.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M451.69,1441.28l-2.89,1.39c-.52-1.14-.91-2-1.3-2.89.41-.17.68-.38.82-.32C449.32,1440,450.3,1440.52,451.69,1441.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M471.68,1467.12l-2.88-1.55,2.88-1.68c.44.76.81,1.4,1.19,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.53,1478.53c1.22.11,2.64-.49,3.59,1.15l-1.86,1.32C465,1481.47,464,1480.08,463.53,1478.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M499.84,1497.56l2,1.83v1.49l-2,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M439.28,1430.75l1,2-2.31,1.11c-.29-.45-.52-.65-.5-.82C437.66,1431.61,437.67,1431.61,439.28,1430.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.18,1459.5l-1.55,1.86c-1.52-.8-2.14-1.67-1.25-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M522.44,1502.56l-1.12,3.16-1.78-2.52C519.8,1502.41,520.75,1502.29,522.44,1502.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M438.94,1444.85l-1.07,1.07-2.59-2.86.42-.86C437.18,1442.69,437.85,1444,438.94,1444.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M466.2,1514.66h-2.4c-.68-1.15-.2-2,.95-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M504.89,1484.79c.11.11.41.46.86,1l-1.52,1.69-1.24-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M526.38,1504.53h-1.75c-.36-.36-.69-.7-1-1l1-1h1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M510.53,1512.94l2.15-1.94c.35.15.53.17.54.23.12.56.21,1.13.3,1.63l-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.15,1485.56l-1.58.22c-.58-1.1-1.17-2.23-1.86-3.56C447.17,1482.07,446.72,1484.36,448.15,1485.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M507.53,1514.56h-4.78c-.05-.25-.12-.57-.18-.85,1.08-1.37,2.36.75,3.47-.26A11.45,11.45,0,0,1,507.53,1514.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M477.48,1483.44l1.7.73.68-.59,1,1.27-1.25.61-2.35-.73C477.3,1484.34,477.36,1484,477.48,1483.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M525,1506.43l1.13-1.13,2.21.17-1.67,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.18,1467l.94-2.45,2,1C461.67,1467.1,460.42,1467,459.18,1467Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.75,1428.64l-2.92-.23,2.42-2.6C447.46,1427,447.57,1427.6,447.75,1428.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M489.64,1472.59c-.08,1.05-.14,1.7-.24,2.93l-2.59-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M490.2,1510l1.52-.54,1.16.71c-.58.69-.95,1.12-1.57,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.8,1489.72l2.46,1.42-2.06,1.58C460.05,1491.63,460,1491,459.8,1489.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M510.72,1509l-.79-1.19,1.89-1.43c.1,1.05.17,1.69.25,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M458.46,1469.12a1.78,1.78,0,0,1,2.17,1.45l-.72.72h-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M478.62,1486.55h2.13c.07.37.13.7.24,1.25l-2.1.17C478.81,1487.51,478.74,1487.19,478.62,1486.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M475,1478.47h-1.21v-2H475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M469.42,1514.61l1.69-2.13c.35.71.66,1.36,1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M527.6,1498.9l-2-1.08,1.38-1.1,1.16,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M495,1510.38h-1.62c-.06-.67-.11-1.37-.17-2.06l.48-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M520,1509.28l1-1,1,.9C521,1510.37,521,1510.37,520,1509.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459,1512.37l.67-1.62,2,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M503.8,1493.35l-2.28-1.67h2.6C504,1492.23,503.94,1492.64,503.8,1493.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M489.15,1483.94c-.16-.7-.24-1.1-.36-1.66h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M436.37,1439.19l-1.68.31v-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465.44,1460.09c.14.72.21,1.13.31,1.67h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.15,1451.63l-2,1.07c-.15-.57-.26-1-.37-1.37C442.68,1451,443.46,1450.7,444.15,1451.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.93,1451.84h2.6l-2.23,1.75C444.12,1452.75,444,1452.26,443.93,1451.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M452.31,1456.82l1.06,1.06-1.15,1.23-.93-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M451.22,1495.9l1.1-1.67c.27.66.47,1.18.7,1.77l-.35.63h-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M438.25,1462.87v-2.19c.82.15,1.45.45,1.38,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M494.62,1500.22l1.38.1c0,.44.06.75.1,1.24l-1.36.15C494.69,1501.11,494.66,1500.68,494.62,1500.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M457,1502v1.75l-1.37.29c.39-.91.7-1.61,1-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M496.88,1481.42v-1.29l1.07-.21C498.51,1480.88,498.5,1481.48,496.88,1481.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M462.05,1465.53c0-.46.07-.9.11-1.37l1.23-.11c.05.44.09.84.15,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M499,1509.85v1.05l-1.27.26c-.09-.47-.16-.79-.26-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497.55,1498.61v-1l1.27-.27c.09.47.16.8.26,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.6,1434.19v-1l1.27-.27c.1.47.16.8.27,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M520.68,1513.25l1.38.1c0,.44.06.75.1,1.23l-1.36.15C520.75,1514.14,520.72,1513.71,520.68,1513.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M436.56,1448.85V1451h-.36v-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.75,1447.13c.32.65.56,1.13.81,1.61C440.86,1448.86,439.92,1449.23,440.75,1447.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M480.61,1480.62l.54,1.51C480.46,1482.43,480.16,1482,480.61,1480.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M438.48,1426.49l-.7-1.44C438.66,1424.72,439,1425.16,438.48,1426.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508.52,1514.12h1.92c0,.13,0,.25,0,.37l-1.9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M523,1514.12h1.92c0,.13,0,.25,0,.37l-1.89.28C523,1514.55,523,1514.34,523,1514.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M477.1,1498.27l1.4-.27c.1.44.18.84.44,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M521.16,1496.47c-.36-1-.55-1.55-.63-1.79C521.28,1494.5,521.28,1494.5,521.16,1496.47Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 452.67,
    cy: 1493.37,
    rx: 1.02,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.14,1463.93h-1.2c0-.11,0-.23-.05-.34l1.18-.28C443.09,1463.51,443.12,1463.72,443.14,1463.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M476,1505.33l-.12-1.39.47,0c.09.47.19.94.28,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M533.92,1508.21v-1.45h.36v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M533.5,1509.66v.72h-.24v-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M502.37,1511.1v.73h-.24v-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M460.63,1496.63v.72h-.72v-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M490.07,1514v.72h-.24V1514Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 510.94,
    cy: 1498.44,
    rx: 0.51,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M478.49,1474.19v.72h-.25v-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.92,1462.68l-.59-.5.22-.23.51.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M442.6,1460.36l.59.5-.23.23-.5-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M496.34,1494.46v-.73h.24v.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideImg1);
export default __webpack_public_path__ + "static/media/slide_img_1.dbea31d47b57c44980c68a7618f19c38.svg";
export { ForwardRef as ReactComponent };